/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string; output: string; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AccountLink = Node & {
  __typename?: 'AccountLink';
  accountIdSs58: Scalars['String']['output'];
  ethereumAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type AccountLinkAggregates = {
  __typename?: 'AccountLinkAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountLinkAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountLinkDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountLinkMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountLinkMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountLinkStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountLinkStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountLinkSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountLinkVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountLinkVarianceSampleAggregates>;
};

export type AccountLinkAverageAggregates = {
  __typename?: 'AccountLinkAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountLink` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AccountLinkCondition = {
  /** Checks for equality with the object’s `accountIdSs58` field. */
  accountIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ethereumAddress` field. */
  ethereumAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountLinkDistinctCountAggregates = {
  __typename?: 'AccountLinkDistinctCountAggregates';
  /** Distinct count of accountIdSs58 across the matching connection */
  accountIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ethereumAddress across the matching connection */
  ethereumAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `AccountLink` object types. All fields are combined with a logical ‘and.’ */
export type AccountLinkFilter = {
  /** Filter by the object’s `accountIdSs58` field. */
  accountIdSs58?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountLinkFilter>>;
  /** Filter by the object’s `ethereumAddress` field. */
  ethereumAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountLinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountLinkFilter>>;
};

/** Grouping methods for `AccountLink` for usage during aggregation. */
export type AccountLinkGroupBy =
  | 'ACCOUNT_ID_SS58'
  | 'ETHEREUM_ADDRESS';

export type AccountLinkHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AccountLink` aggregates. */
export type AccountLinkHavingInput = {
  AND?: InputMaybe<Array<AccountLinkHavingInput>>;
  OR?: InputMaybe<Array<AccountLinkHavingInput>>;
  average?: InputMaybe<AccountLinkHavingAverageInput>;
  distinctCount?: InputMaybe<AccountLinkHavingDistinctCountInput>;
  max?: InputMaybe<AccountLinkHavingMaxInput>;
  min?: InputMaybe<AccountLinkHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountLinkHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountLinkHavingStddevSampleInput>;
  sum?: InputMaybe<AccountLinkHavingSumInput>;
  variancePopulation?: InputMaybe<AccountLinkHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountLinkHavingVarianceSampleInput>;
};

export type AccountLinkHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountLinkMaxAggregates = {
  __typename?: 'AccountLinkMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountLinkMinAggregates = {
  __typename?: 'AccountLinkMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountLinkStddevPopulationAggregates = {
  __typename?: 'AccountLinkStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountLinkStddevSampleAggregates = {
  __typename?: 'AccountLinkStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountLinkSumAggregates = {
  __typename?: 'AccountLinkSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type AccountLinkVariancePopulationAggregates = {
  __typename?: 'AccountLinkVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountLinkVarianceSampleAggregates = {
  __typename?: 'AccountLinkVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `AccountLink` values. */
export type AccountLinksConnection = {
  __typename?: 'AccountLinksConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountLinkAggregates>;
  /** A list of edges which contains the `AccountLink` and cursor to aid in pagination. */
  edges: Array<AccountLinksEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountLinkAggregates>>;
  /** A list of `AccountLink` objects. */
  nodes: Array<AccountLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountLink` values. */
export type AccountLinksConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountLinkGroupBy>;
  having?: InputMaybe<AccountLinkHavingInput>;
};

/** A `AccountLink` edge in the connection. */
export type AccountLinksEdge = {
  __typename?: 'AccountLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountLink` at the end of the edge. */
  node: AccountLink;
};

/** Methods to use when ordering `AccountLink`. */
export type AccountLinksOrderBy =
  | 'ACCOUNT_ID_SS58_ASC'
  | 'ACCOUNT_ID_SS58_DESC'
  | 'ETHEREUM_ADDRESS_ASC'
  | 'ETHEREUM_ADDRESS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type AccountRole =
  | 'LIQUIDITY_PROVIDER'
  | 'UNREGISTERED'
  | 'VALIDATOR';

/** A filter to be used against AccountRole fields. All fields are combined with a logical ‘and.’ */
export type AccountRoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AccountRole>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AccountRole>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AccountRole>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AccountRole>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AccountRole>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AccountRole>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AccountRole>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AccountRole>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AccountRole>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AccountRole>>;
};

export type App =
  | 'ALL'
  | 'EXPLORER'
  | 'LP'
  | 'STAKE'
  | 'SWAP';

/** A filter to be used against App fields. All fields are combined with a logical ‘and.’ */
export type AppFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<App>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<App>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<App>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<App>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<App>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<App>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<App>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<App>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<App>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<App>>;
};

export type Auction = Node & {
  __typename?: 'Auction';
  authorityRotationEnabled: Scalars['Boolean']['output'];
  currentHeight: Scalars['Int']['output'];
  endBlockNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  redemptionPeriodAsPercentage: Scalars['Int']['output'];
  startBlockNumber: Scalars['Int']['output'];
  targetSetSize: Scalars['Int']['output'];
};

export type AuctionAggregates = {
  __typename?: 'AuctionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AuctionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuctionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AuctionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AuctionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AuctionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AuctionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AuctionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AuctionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AuctionVarianceSampleAggregates>;
};

export type AuctionAverageAggregates = {
  __typename?: 'AuctionAverageAggregates';
  /** Mean average of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Auction` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AuctionCondition = {
  /** Checks for equality with the object’s `authorityRotationEnabled` field. */
  authorityRotationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `currentHeight` field. */
  currentHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `endBlockNumber` field. */
  endBlockNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minActiveBid` field. */
  minActiveBid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedLockup` field. */
  projectedLockup?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `redemptionPeriodAsPercentage` field. */
  redemptionPeriodAsPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startBlockNumber` field. */
  startBlockNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `targetSetSize` field. */
  targetSetSize?: InputMaybe<Scalars['Int']['input']>;
};

export type AuctionDistinctCountAggregates = {
  __typename?: 'AuctionDistinctCountAggregates';
  /** Distinct count of authorityRotationEnabled across the matching connection */
  authorityRotationEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Auction` object types. All fields are combined with a logical ‘and.’ */
export type AuctionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuctionFilter>>;
  /** Filter by the object’s `authorityRotationEnabled` field. */
  authorityRotationEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `currentHeight` field. */
  currentHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endBlockNumber` field. */
  endBlockNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minActiveBid` field. */
  minActiveBid?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuctionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuctionFilter>>;
  /** Filter by the object’s `projectedLockup` field. */
  projectedLockup?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `redemptionPeriodAsPercentage` field. */
  redemptionPeriodAsPercentage?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startBlockNumber` field. */
  startBlockNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `targetSetSize` field. */
  targetSetSize?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Auction` for usage during aggregation. */
export type AuctionGroupBy =
  | 'AUTHORITY_ROTATION_ENABLED'
  | 'CURRENT_HEIGHT'
  | 'END_BLOCK_NUMBER'
  | 'MIN_ACTIVE_BID'
  | 'PROJECTED_LOCKUP'
  | 'REDEMPTION_PERIOD_AS_PERCENTAGE'
  | 'START_BLOCK_NUMBER'
  | 'TARGET_SET_SIZE';

export type AuctionHavingAverageInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingDistinctCountInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Auction` aggregates. */
export type AuctionHavingInput = {
  AND?: InputMaybe<Array<AuctionHavingInput>>;
  OR?: InputMaybe<Array<AuctionHavingInput>>;
  average?: InputMaybe<AuctionHavingAverageInput>;
  distinctCount?: InputMaybe<AuctionHavingDistinctCountInput>;
  max?: InputMaybe<AuctionHavingMaxInput>;
  min?: InputMaybe<AuctionHavingMinInput>;
  stddevPopulation?: InputMaybe<AuctionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuctionHavingStddevSampleInput>;
  sum?: InputMaybe<AuctionHavingSumInput>;
  variancePopulation?: InputMaybe<AuctionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuctionHavingVarianceSampleInput>;
};

export type AuctionHavingMaxInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingMinInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingStddevPopulationInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingStddevSampleInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingSumInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingVariancePopulationInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingVarianceSampleInput = {
  currentHeight?: InputMaybe<HavingIntFilter>;
  endBlockNumber?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  minActiveBid?: InputMaybe<HavingBigfloatFilter>;
  projectedLockup?: InputMaybe<HavingBigfloatFilter>;
  redemptionPeriodAsPercentage?: InputMaybe<HavingIntFilter>;
  startBlockNumber?: InputMaybe<HavingIntFilter>;
  targetSetSize?: InputMaybe<HavingIntFilter>;
};

export type AuctionMaxAggregates = {
  __typename?: 'AuctionMaxAggregates';
  /** Maximum of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Maximum of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['Int']['output']>;
};

export type AuctionMinAggregates = {
  __typename?: 'AuctionMinAggregates';
  /** Minimum of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['Int']['output']>;
  /** Minimum of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['Int']['output']>;
  /** Minimum of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['Int']['output']>;
};

export type AuctionStddevPopulationAggregates = {
  __typename?: 'AuctionStddevPopulationAggregates';
  /** Population standard deviation of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionStddevSampleAggregates = {
  __typename?: 'AuctionStddevSampleAggregates';
  /** Sample standard deviation of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionSumAggregates = {
  __typename?: 'AuctionSumAggregates';
  /** Sum of currentHeight across the matching connection */
  currentHeight: Scalars['BigInt']['output'];
  /** Sum of endBlockNumber across the matching connection */
  endBlockNumber: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of minActiveBid across the matching connection */
  minActiveBid: Scalars['BigFloat']['output'];
  /** Sum of projectedLockup across the matching connection */
  projectedLockup: Scalars['BigFloat']['output'];
  /** Sum of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage: Scalars['BigInt']['output'];
  /** Sum of startBlockNumber across the matching connection */
  startBlockNumber: Scalars['BigInt']['output'];
  /** Sum of targetSetSize across the matching connection */
  targetSetSize: Scalars['BigInt']['output'];
};

export type AuctionVariancePopulationAggregates = {
  __typename?: 'AuctionVariancePopulationAggregates';
  /** Population variance of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionVarianceSampleAggregates = {
  __typename?: 'AuctionVarianceSampleAggregates';
  /** Sample variance of currentHeight across the matching connection */
  currentHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of endBlockNumber across the matching connection */
  endBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minActiveBid across the matching connection */
  minActiveBid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedLockup across the matching connection */
  projectedLockup?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of redemptionPeriodAsPercentage across the matching connection */
  redemptionPeriodAsPercentage?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockNumber across the matching connection */
  startBlockNumber?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of targetSetSize across the matching connection */
  targetSetSize?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Auction` values. */
export type AuctionsConnection = {
  __typename?: 'AuctionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuctionAggregates>;
  /** A list of edges which contains the `Auction` and cursor to aid in pagination. */
  edges: Array<AuctionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuctionAggregates>>;
  /** A list of `Auction` objects. */
  nodes: Array<Auction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Auction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Auction` values. */
export type AuctionsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AuctionGroupBy>;
  having?: InputMaybe<AuctionHavingInput>;
};

/** A `Auction` edge in the connection. */
export type AuctionsEdge = {
  __typename?: 'AuctionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Auction` at the end of the edge. */
  node: Auction;
};

/** Methods to use when ordering `Auction`. */
export type AuctionsOrderBy =
  | 'AUTHORITY_ROTATION_ENABLED_ASC'
  | 'AUTHORITY_ROTATION_ENABLED_DESC'
  | 'CURRENT_HEIGHT_ASC'
  | 'CURRENT_HEIGHT_DESC'
  | 'END_BLOCK_NUMBER_ASC'
  | 'END_BLOCK_NUMBER_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MIN_ACTIVE_BID_ASC'
  | 'MIN_ACTIVE_BID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECTED_LOCKUP_ASC'
  | 'PROJECTED_LOCKUP_DESC'
  | 'REDEMPTION_PERIOD_AS_PERCENTAGE_ASC'
  | 'REDEMPTION_PERIOD_AS_PERCENTAGE_DESC'
  | 'START_BLOCK_NUMBER_ASC'
  | 'START_BLOCK_NUMBER_DESC'
  | 'TARGET_SET_SIZE_ASC'
  | 'TARGET_SET_SIZE_DESC';

export type Banner = Node & {
  __typename?: 'Banner';
  app: App;
  message: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  type: BannerType;
};

export type BannerAggregates = {
  __typename?: 'BannerAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BannerDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/** A condition to be used against `Banner` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BannerCondition = {
  /** Checks for equality with the object’s `app` field. */
  app?: InputMaybe<App>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<BannerType>;
};

export type BannerDistinctCountAggregates = {
  __typename?: 'BannerDistinctCountAggregates';
  /** Distinct count of app across the matching connection */
  app?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of message across the matching connection */
  message?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Banner` object types. All fields are combined with a logical ‘and.’ */
export type BannerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BannerFilter>>;
  /** Filter by the object’s `app` field. */
  app?: InputMaybe<AppFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BannerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BannerFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<BannerTypeFilter>;
};

/** Grouping methods for `Banner` for usage during aggregation. */
export type BannerGroupBy =
  | 'MESSAGE'
  | 'TYPE';

/** Conditions for `Banner` aggregates. */
export type BannerHavingInput = {
  AND?: InputMaybe<Array<BannerHavingInput>>;
  OR?: InputMaybe<Array<BannerHavingInput>>;
};

export type BannerType =
  | 'INFO'
  | 'SUCCESS'
  | 'WARNING';

/** A filter to be used against BannerType fields. All fields are combined with a logical ‘and.’ */
export type BannerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BannerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BannerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BannerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BannerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BannerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BannerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BannerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BannerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BannerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BannerType>>;
};

/** A connection to a list of `Banner` values. */
export type BannersConnection = {
  __typename?: 'BannersConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BannerAggregates>;
  /** A list of edges which contains the `Banner` and cursor to aid in pagination. */
  edges: Array<BannersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BannerAggregates>>;
  /** A list of `Banner` objects. */
  nodes: Array<Banner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Banner` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Banner` values. */
export type BannersConnectionGroupedAggregatesArgs = {
  groupBy: Array<BannerGroupBy>;
  having?: InputMaybe<BannerHavingInput>;
};

/** A `Banner` edge in the connection. */
export type BannersEdge = {
  __typename?: 'BannersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Banner` at the end of the edge. */
  node: Banner;
};

/** Methods to use when ordering `Banner`. */
export type BannersOrderBy =
  | 'APP_ASC'
  | 'APP_DESC'
  | 'MESSAGE_ASC'
  | 'MESSAGE_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BoostBalance = {
  __typename?: 'BoostBalance';
  availableAmount: Scalars['BigFloat']['output'];
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `BoostPool` that is related to this `BoostBalance`. */
  boostPoolByPoolId: BoostPool;
  /** Reads a single `LpAccount` that is related to this `BoostBalance`. */
  lpAccountByLpIdSs58: LpAccount;
  lpIdSs58: Scalars['String']['output'];
  poolId: Scalars['Int']['output'];
  poolShare: Scalars['Float']['output'];
  unavailableAmount: Scalars['BigFloat']['output'];
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

export type BoostBalanceAggregates = {
  __typename?: 'BoostBalanceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostBalanceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostBalanceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostBalanceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostBalanceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostBalanceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostBalanceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostBalanceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostBalanceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostBalanceVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostBalance` object types. */
export type BoostBalanceAggregatesFilter = {
  /** Mean average aggregate over matching `BoostBalance` objects. */
  average?: InputMaybe<BoostBalanceAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostBalance` objects. */
  distinctCount?: InputMaybe<BoostBalanceDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostBalance` object to be included within the aggregate. */
  filter?: InputMaybe<BoostBalanceFilter>;
  /** Maximum aggregate over matching `BoostBalance` objects. */
  max?: InputMaybe<BoostBalanceMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostBalance` objects. */
  min?: InputMaybe<BoostBalanceMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostBalance` objects. */
  stddevPopulation?: InputMaybe<BoostBalanceStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostBalance` objects. */
  stddevSample?: InputMaybe<BoostBalanceStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostBalance` objects. */
  sum?: InputMaybe<BoostBalanceSumAggregateFilter>;
  /** Population variance aggregate over matching `BoostBalance` objects. */
  variancePopulation?: InputMaybe<BoostBalanceVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostBalance` objects. */
  varianceSample?: InputMaybe<BoostBalanceVarianceSampleAggregateFilter>;
};

export type BoostBalanceAverageAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceAverageAggregates = {
  __typename?: 'BoostBalanceAverageAggregates';
  /** Mean average of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Mean average of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BoostBalanceCondition = {
  /** Checks for equality with the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `poolId` field. */
  poolId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `poolShare` field. */
  poolShare?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BoostBalanceDistinctCountAggregateFilter = {
  availableAmount?: InputMaybe<BigIntFilter>;
  availableAmountValueUsd?: InputMaybe<BigIntFilter>;
  lpIdSs58?: InputMaybe<BigIntFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  poolShare?: InputMaybe<BigIntFilter>;
  unavailableAmount?: InputMaybe<BigIntFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigIntFilter>;
};

export type BoostBalanceDistinctCountAggregates = {
  __typename?: 'BoostBalanceDistinctCountAggregates';
  /** Distinct count of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpIdSs58 across the matching connection */
  lpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostBalance` object types. All fields are combined with a logical ‘and.’ */
export type BoostBalanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostBalanceFilter>>;
  /** Filter by the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `boostPoolByPoolId` relation. */
  boostPoolByPoolId?: InputMaybe<BoostPoolFilter>;
  /** Filter by the object’s `lpAccountByLpIdSs58` relation. */
  lpAccountByLpIdSs58?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostBalanceFilter>>;
  /** Filter by the object’s `poolId` field. */
  poolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `poolShare` field. */
  poolShare?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BoostBalance` for usage during aggregation. */
export type BoostBalanceGroupBy =
  | 'AVAILABLE_AMOUNT'
  | 'AVAILABLE_AMOUNT_VALUE_USD'
  | 'LP_ID_SS58'
  | 'POOL_ID'
  | 'POOL_SHARE'
  | 'UNAVAILABLE_AMOUNT'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD';

export type BoostBalanceHavingAverageInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingDistinctCountInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BoostBalance` aggregates. */
export type BoostBalanceHavingInput = {
  AND?: InputMaybe<Array<BoostBalanceHavingInput>>;
  OR?: InputMaybe<Array<BoostBalanceHavingInput>>;
  average?: InputMaybe<BoostBalanceHavingAverageInput>;
  distinctCount?: InputMaybe<BoostBalanceHavingDistinctCountInput>;
  max?: InputMaybe<BoostBalanceHavingMaxInput>;
  min?: InputMaybe<BoostBalanceHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostBalanceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostBalanceHavingStddevSampleInput>;
  sum?: InputMaybe<BoostBalanceHavingSumInput>;
  variancePopulation?: InputMaybe<BoostBalanceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostBalanceHavingVarianceSampleInput>;
};

export type BoostBalanceHavingMaxInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingMinInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingStddevPopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingStddevSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingSumInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingVariancePopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceHavingVarianceSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  poolId?: InputMaybe<HavingIntFilter>;
  poolShare?: InputMaybe<HavingFloatFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostBalanceMaxAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceMaxAggregates = {
  __typename?: 'BoostBalanceMaxAggregates';
  /** Maximum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Maximum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceMinAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<IntFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceMinAggregates = {
  __typename?: 'BoostBalanceMinAggregates';
  /** Minimum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of poolId across the matching connection */
  poolId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Minimum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceStddevPopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceStddevPopulationAggregates = {
  __typename?: 'BoostBalanceStddevPopulationAggregates';
  /** Population standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceStddevSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceStddevSampleAggregates = {
  __typename?: 'BoostBalanceStddevSampleAggregates';
  /** Sample standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceSumAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigIntFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceSumAggregates = {
  __typename?: 'BoostBalanceSumAggregates';
  /** Sum of availableAmount across the matching connection */
  availableAmount: Scalars['BigFloat']['output'];
  /** Sum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of poolId across the matching connection */
  poolId: Scalars['BigInt']['output'];
  /** Sum of poolShare across the matching connection */
  poolShare: Scalars['Float']['output'];
  /** Sum of unavailableAmount across the matching connection */
  unavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

export type BoostBalanceVariancePopulationAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceVariancePopulationAggregates = {
  __typename?: 'BoostBalanceVariancePopulationAggregates';
  /** Population variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Population variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostBalanceVarianceSampleAggregateFilter = {
  availableAmount?: InputMaybe<BigFloatFilter>;
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  poolId?: InputMaybe<BigFloatFilter>;
  poolShare?: InputMaybe<FloatFilter>;
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostBalanceVarianceSampleAggregates = {
  __typename?: 'BoostBalanceVarianceSampleAggregates';
  /** Sample variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolId across the matching connection */
  poolId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of poolShare across the matching connection */
  poolShare?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostBalance` values. */
export type BoostBalancesConnection = {
  __typename?: 'BoostBalancesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostBalanceAggregates>;
  /** A list of edges which contains the `BoostBalance` and cursor to aid in pagination. */
  edges: Array<BoostBalancesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostBalanceAggregates>>;
  /** A list of `BoostBalance` objects. */
  nodes: Array<BoostBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostBalance` values. */
export type BoostBalancesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostBalanceGroupBy>;
  having?: InputMaybe<BoostBalanceHavingInput>;
};

/** A `BoostBalance` edge in the connection. */
export type BoostBalancesEdge = {
  __typename?: 'BoostBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostBalance` at the end of the edge. */
  node: BoostBalance;
};

/** Methods to use when ordering `BoostBalance`. */
export type BoostBalancesOrderBy =
  | 'AVAILABLE_AMOUNT_ASC'
  | 'AVAILABLE_AMOUNT_DESC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'LP_ID_SS58_ASC'
  | 'LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'POOL_ID_ASC'
  | 'POOL_ID_DESC'
  | 'POOL_SHARE_ASC'
  | 'POOL_SHARE_DESC'
  | 'UNAVAILABLE_AMOUNT_ASC'
  | 'UNAVAILABLE_AMOUNT_DESC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_DESC';

export type BoostPool = Node & {
  __typename?: 'BoostPool';
  asset: ChainflipAsset;
  availableAmount: Scalars['BigFloat']['output'];
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `BoostBalance`. */
  boostBalancesByPoolId: BoostBalancesConnection;
  chain: ChainflipChain;
  feeTierPips: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  unavailableAmount: Scalars['BigFloat']['output'];
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};


export type BoostPoolBoostBalancesByPoolIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostBalanceCondition>;
  filter?: InputMaybe<BoostBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostBalancesOrderBy>>;
};

export type BoostPoolAggregates = {
  __typename?: 'BoostPoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostPoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostPoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostPoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostPoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostPoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostPoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostPoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostPoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostPoolVarianceSampleAggregates>;
};

export type BoostPoolAverageAggregates = {
  __typename?: 'BoostPoolAverageAggregates';
  /** Mean average of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostPool` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BoostPoolCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `feeTierPips` field. */
  feeTierPips?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BoostPoolDistinctCountAggregates = {
  __typename?: 'BoostPoolDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostPool` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostPoolFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `availableAmount` field. */
  availableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `availableAmountValueUsd` field. */
  availableAmountValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `boostBalancesByPoolId` relation. */
  boostBalancesByPoolId?: InputMaybe<BoostPoolToManyBoostBalanceFilter>;
  /** Some related `boostBalancesByPoolId` exist. */
  boostBalancesByPoolIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `feeTierPips` field. */
  feeTierPips?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostPoolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostPoolFilter>>;
  /** Filter by the object’s `unavailableAmount` field. */
  unavailableAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `unavailableAmountValueUsd` field. */
  unavailableAmountValueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BoostPool` for usage during aggregation. */
export type BoostPoolGroupBy =
  | 'ASSET'
  | 'AVAILABLE_AMOUNT'
  | 'AVAILABLE_AMOUNT_VALUE_USD'
  | 'CHAIN'
  | 'FEE_TIER_PIPS'
  | 'UNAVAILABLE_AMOUNT'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD';

export type BoostPoolHavingAverageInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingDistinctCountInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BoostPool` aggregates. */
export type BoostPoolHavingInput = {
  AND?: InputMaybe<Array<BoostPoolHavingInput>>;
  OR?: InputMaybe<Array<BoostPoolHavingInput>>;
  average?: InputMaybe<BoostPoolHavingAverageInput>;
  distinctCount?: InputMaybe<BoostPoolHavingDistinctCountInput>;
  max?: InputMaybe<BoostPoolHavingMaxInput>;
  min?: InputMaybe<BoostPoolHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostPoolHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostPoolHavingStddevSampleInput>;
  sum?: InputMaybe<BoostPoolHavingSumInput>;
  variancePopulation?: InputMaybe<BoostPoolHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostPoolHavingVarianceSampleInput>;
};

export type BoostPoolHavingMaxInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingMinInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingStddevPopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingStddevSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingSumInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingVariancePopulationInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolHavingVarianceSampleInput = {
  availableAmount?: InputMaybe<HavingBigfloatFilter>;
  availableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
  feeTierPips?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  unavailableAmount?: InputMaybe<HavingBigfloatFilter>;
  unavailableAmountValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostPoolMaxAggregates = {
  __typename?: 'BoostPoolMaxAggregates';
  /** Maximum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolMinAggregates = {
  __typename?: 'BoostPoolMinAggregates';
  /** Minimum of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolStddevPopulationAggregates = {
  __typename?: 'BoostPoolStddevPopulationAggregates';
  /** Population standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolStddevSampleAggregates = {
  __typename?: 'BoostPoolStddevSampleAggregates';
  /** Sample standard deviation of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolSumAggregates = {
  __typename?: 'BoostPoolSumAggregates';
  /** Sum of availableAmount across the matching connection */
  availableAmount: Scalars['BigFloat']['output'];
  /** Sum of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd: Scalars['BigFloat']['output'];
  /** Sum of feeTierPips across the matching connection */
  feeTierPips: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of unavailableAmount across the matching connection */
  unavailableAmount: Scalars['BigFloat']['output'];
  /** Sum of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `BoostBalance` object types. All fields are combined with a logical ‘and.’ */
export type BoostPoolToManyBoostBalanceFilter = {
  /** Aggregates across related `BoostBalance` match the filter criteria. */
  aggregates?: InputMaybe<BoostBalanceAggregatesFilter>;
  /** Every related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostBalanceFilter>;
  /** No related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostBalanceFilter>;
  /** Some related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostBalanceFilter>;
};

export type BoostPoolVariancePopulationAggregates = {
  __typename?: 'BoostPoolVariancePopulationAggregates';
  /** Population variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostPoolVarianceSampleAggregates = {
  __typename?: 'BoostPoolVarianceSampleAggregates';
  /** Sample variance of availableAmount across the matching connection */
  availableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of availableAmountValueUsd across the matching connection */
  availableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeTierPips across the matching connection */
  feeTierPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmount across the matching connection */
  unavailableAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unavailableAmountValueUsd across the matching connection */
  unavailableAmountValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostPool` values. */
export type BoostPoolsConnection = {
  __typename?: 'BoostPoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostPoolAggregates>;
  /** A list of edges which contains the `BoostPool` and cursor to aid in pagination. */
  edges: Array<BoostPoolsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostPoolAggregates>>;
  /** A list of `BoostPool` objects. */
  nodes: Array<BoostPool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostPool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostPool` values. */
export type BoostPoolsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostPoolGroupBy>;
  having?: InputMaybe<BoostPoolHavingInput>;
};

/** A `BoostPool` edge in the connection. */
export type BoostPoolsEdge = {
  __typename?: 'BoostPoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostPool` at the end of the edge. */
  node: BoostPool;
};

/** Methods to use when ordering `BoostPool`. */
export type BoostPoolsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'AVAILABLE_AMOUNT_ASC'
  | 'AVAILABLE_AMOUNT_DESC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_COUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_COUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_POOL_ID_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'FEE_TIER_PIPS_ASC'
  | 'FEE_TIER_PIPS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UNAVAILABLE_AMOUNT_ASC'
  | 'UNAVAILABLE_AMOUNT_DESC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'UNAVAILABLE_AMOUNT_VALUE_USD_DESC';

export type BoostSafeMode = Node & {
  __typename?: 'BoostSafeMode';
  addBoostFundsEnabled: Scalars['Boolean']['output'];
  boostDepositsEnabled: Scalars['Boolean']['output'];
  chain: ChainflipChain;
  depositsEnabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  stopBoostingEnabled: Scalars['Boolean']['output'];
};

export type BoostSafeModeAggregates = {
  __typename?: 'BoostSafeModeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostSafeModeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostSafeModeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostSafeModeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostSafeModeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostSafeModeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostSafeModeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostSafeModeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostSafeModeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostSafeModeVarianceSampleAggregates>;
};

export type BoostSafeModeAverageAggregates = {
  __typename?: 'BoostSafeModeAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostSafeMode` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BoostSafeModeCondition = {
  /** Checks for equality with the object’s `addBoostFundsEnabled` field. */
  addBoostFundsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `boostDepositsEnabled` field. */
  boostDepositsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `depositsEnabled` field. */
  depositsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stopBoostingEnabled` field. */
  stopBoostingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoostSafeModeDistinctCountAggregates = {
  __typename?: 'BoostSafeModeDistinctCountAggregates';
  /** Distinct count of addBoostFundsEnabled across the matching connection */
  addBoostFundsEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostDepositsEnabled across the matching connection */
  boostDepositsEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositsEnabled across the matching connection */
  depositsEnabled?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stopBoostingEnabled across the matching connection */
  stopBoostingEnabled?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostSafeMode` object types. All fields are combined with a logical ‘and.’ */
export type BoostSafeModeFilter = {
  /** Filter by the object’s `addBoostFundsEnabled` field. */
  addBoostFundsEnabled?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostSafeModeFilter>>;
  /** Filter by the object’s `boostDepositsEnabled` field. */
  boostDepositsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `depositsEnabled` field. */
  depositsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostSafeModeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostSafeModeFilter>>;
  /** Filter by the object’s `stopBoostingEnabled` field. */
  stopBoostingEnabled?: InputMaybe<BooleanFilter>;
};

/** Grouping methods for `BoostSafeMode` for usage during aggregation. */
export type BoostSafeModeGroupBy =
  | 'ADD_BOOST_FUNDS_ENABLED'
  | 'BOOST_DEPOSITS_ENABLED'
  | 'DEPOSITS_ENABLED'
  | 'STOP_BOOSTING_ENABLED';

export type BoostSafeModeHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BoostSafeMode` aggregates. */
export type BoostSafeModeHavingInput = {
  AND?: InputMaybe<Array<BoostSafeModeHavingInput>>;
  OR?: InputMaybe<Array<BoostSafeModeHavingInput>>;
  average?: InputMaybe<BoostSafeModeHavingAverageInput>;
  distinctCount?: InputMaybe<BoostSafeModeHavingDistinctCountInput>;
  max?: InputMaybe<BoostSafeModeHavingMaxInput>;
  min?: InputMaybe<BoostSafeModeHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostSafeModeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostSafeModeHavingStddevSampleInput>;
  sum?: InputMaybe<BoostSafeModeHavingSumInput>;
  variancePopulation?: InputMaybe<BoostSafeModeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostSafeModeHavingVarianceSampleInput>;
};

export type BoostSafeModeHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type BoostSafeModeMaxAggregates = {
  __typename?: 'BoostSafeModeMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BoostSafeModeMinAggregates = {
  __typename?: 'BoostSafeModeMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BoostSafeModeStddevPopulationAggregates = {
  __typename?: 'BoostSafeModeStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostSafeModeStddevSampleAggregates = {
  __typename?: 'BoostSafeModeStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostSafeModeSumAggregates = {
  __typename?: 'BoostSafeModeSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type BoostSafeModeVariancePopulationAggregates = {
  __typename?: 'BoostSafeModeVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostSafeModeVarianceSampleAggregates = {
  __typename?: 'BoostSafeModeVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostSafeMode` values. */
export type BoostSafeModesConnection = {
  __typename?: 'BoostSafeModesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostSafeModeAggregates>;
  /** A list of edges which contains the `BoostSafeMode` and cursor to aid in pagination. */
  edges: Array<BoostSafeModesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostSafeModeAggregates>>;
  /** A list of `BoostSafeMode` objects. */
  nodes: Array<BoostSafeMode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostSafeMode` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostSafeMode` values. */
export type BoostSafeModesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostSafeModeGroupBy>;
  having?: InputMaybe<BoostSafeModeHavingInput>;
};

/** A `BoostSafeMode` edge in the connection. */
export type BoostSafeModesEdge = {
  __typename?: 'BoostSafeModesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostSafeMode` at the end of the edge. */
  node: BoostSafeMode;
};

/** Methods to use when ordering `BoostSafeMode`. */
export type BoostSafeModesOrderBy =
  | 'ADD_BOOST_FUNDS_ENABLED_ASC'
  | 'ADD_BOOST_FUNDS_ENABLED_DESC'
  | 'BOOST_DEPOSITS_ENABLED_ASC'
  | 'BOOST_DEPOSITS_ENABLED_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'DEPOSITS_ENABLED_ASC'
  | 'DEPOSITS_ENABLED_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STOP_BOOSTING_ENABLED_ASC'
  | 'STOP_BOOSTING_ENABLED_DESC';

export type BrokerAccount = Node & {
  __typename?: 'BrokerAccount';
  alias?: Maybe<Scalars['String']['output']>;
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `BrokerAccount` that is related to this `BrokerAccount`. */
  brokerAccountByDelegateBrokerId?: Maybe<BrokerAccount>;
  /** Reads and enables pagination through a set of `BrokerAccountEarnedFee`. */
  brokerAccountEarnedFeesByBrokerAccountIdSs58: BrokerAccountEarnedFeesConnection;
  /** Reads and enables pagination through a set of `BrokerAccount`. */
  brokerAccountsByDelegateBrokerId: BrokerAccountsConnection;
  brokerVaultDepositAddress?: Maybe<Scalars['String']['output']>;
  delegateBrokerId?: Maybe<Scalars['String']['output']>;
  flipBalance: Scalars['BigFloat']['output'];
  idSs58: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  registrationId?: Maybe<Scalars['Int']['output']>;
  withdrawalAddress?: Maybe<Scalars['String']['output']>;
};


export type BrokerAccountBrokerAccountEarnedFeesByBrokerAccountIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAccountEarnedFeeCondition>;
  filter?: InputMaybe<BrokerAccountEarnedFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAccountEarnedFeesOrderBy>>;
};


export type BrokerAccountBrokerAccountsByDelegateBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAccountCondition>;
  filter?: InputMaybe<BrokerAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAccountsOrderBy>>;
};

export type BrokerAccountAggregates = {
  __typename?: 'BrokerAccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerAccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerAccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerAccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerAccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerAccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerAccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerAccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerAccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerAccountVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BrokerAccount` object types. */
export type BrokerAccountAggregatesFilter = {
  /** Mean average aggregate over matching `BrokerAccount` objects. */
  average?: InputMaybe<BrokerAccountAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BrokerAccount` objects. */
  distinctCount?: InputMaybe<BrokerAccountDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BrokerAccount` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerAccountFilter>;
  /** Maximum aggregate over matching `BrokerAccount` objects. */
  max?: InputMaybe<BrokerAccountMaxAggregateFilter>;
  /** Minimum aggregate over matching `BrokerAccount` objects. */
  min?: InputMaybe<BrokerAccountMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BrokerAccount` objects. */
  stddevPopulation?: InputMaybe<BrokerAccountStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BrokerAccount` objects. */
  stddevSample?: InputMaybe<BrokerAccountStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BrokerAccount` objects. */
  sum?: InputMaybe<BrokerAccountSumAggregateFilter>;
  /** Population variance aggregate over matching `BrokerAccount` objects. */
  variancePopulation?: InputMaybe<BrokerAccountVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BrokerAccount` objects. */
  varianceSample?: InputMaybe<BrokerAccountVarianceSampleAggregateFilter>;
};

export type BrokerAccountAverageAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountAverageAggregates = {
  __typename?: 'BrokerAccountAverageAggregates';
  /** Mean average of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BrokerAccountCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bondedFlipBalance` field. */
  bondedFlipBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `brokerVaultDepositAddress` field. */
  brokerVaultDepositAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `delegateBrokerId` field. */
  delegateBrokerId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `registrationId` field. */
  registrationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<Scalars['String']['input']>;
};

export type BrokerAccountDistinctCountAggregateFilter = {
  alias?: InputMaybe<BigIntFilter>;
  bondedFlipBalance?: InputMaybe<BigIntFilter>;
  brokerVaultDepositAddress?: InputMaybe<BigIntFilter>;
  delegateBrokerId?: InputMaybe<BigIntFilter>;
  flipBalance?: InputMaybe<BigIntFilter>;
  idSs58?: InputMaybe<BigIntFilter>;
  registrationId?: InputMaybe<BigIntFilter>;
  withdrawalAddress?: InputMaybe<BigIntFilter>;
};

export type BrokerAccountDistinctCountAggregates = {
  __typename?: 'BrokerAccountDistinctCountAggregates';
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerVaultDepositAddress across the matching connection */
  brokerVaultDepositAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of withdrawalAddress across the matching connection */
  withdrawalAddress?: Maybe<Scalars['BigInt']['output']>;
};

export type BrokerAccountEarnedFee = Node & {
  __typename?: 'BrokerAccountEarnedFee';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `BrokerAccount` that is related to this `BrokerAccountEarnedFee`. */
  brokerAccountByBrokerAccountIdSs58: BrokerAccount;
  brokerAccountIdSs58: Scalars['String']['output'];
  chain: ChainflipChain;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type BrokerAccountEarnedFeeAggregates = {
  __typename?: 'BrokerAccountEarnedFeeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerAccountEarnedFeeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerAccountEarnedFeeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerAccountEarnedFeeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerAccountEarnedFeeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerAccountEarnedFeeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerAccountEarnedFeeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerAccountEarnedFeeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerAccountEarnedFeeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerAccountEarnedFeeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BrokerAccountEarnedFee` object types. */
export type BrokerAccountEarnedFeeAggregatesFilter = {
  /** Mean average aggregate over matching `BrokerAccountEarnedFee` objects. */
  average?: InputMaybe<BrokerAccountEarnedFeeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BrokerAccountEarnedFee` objects. */
  distinctCount?: InputMaybe<BrokerAccountEarnedFeeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BrokerAccountEarnedFee` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerAccountEarnedFeeFilter>;
  /** Maximum aggregate over matching `BrokerAccountEarnedFee` objects. */
  max?: InputMaybe<BrokerAccountEarnedFeeMaxAggregateFilter>;
  /** Minimum aggregate over matching `BrokerAccountEarnedFee` objects. */
  min?: InputMaybe<BrokerAccountEarnedFeeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BrokerAccountEarnedFee` objects. */
  stddevPopulation?: InputMaybe<BrokerAccountEarnedFeeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BrokerAccountEarnedFee` objects. */
  stddevSample?: InputMaybe<BrokerAccountEarnedFeeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BrokerAccountEarnedFee` objects. */
  sum?: InputMaybe<BrokerAccountEarnedFeeSumAggregateFilter>;
  /** Population variance aggregate over matching `BrokerAccountEarnedFee` objects. */
  variancePopulation?: InputMaybe<BrokerAccountEarnedFeeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BrokerAccountEarnedFee` objects. */
  varianceSample?: InputMaybe<BrokerAccountEarnedFeeVarianceSampleAggregateFilter>;
};

export type BrokerAccountEarnedFeeAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountEarnedFeeAverageAggregates = {
  __typename?: 'BrokerAccountEarnedFeeAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerAccountEarnedFee` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BrokerAccountEarnedFeeCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `brokerAccountIdSs58` field. */
  brokerAccountIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BrokerAccountEarnedFeeDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  brokerAccountIdSs58?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BrokerAccountEarnedFeeDistinctCountAggregates = {
  __typename?: 'BrokerAccountEarnedFeeDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerAccountIdSs58 across the matching connection */
  brokerAccountIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BrokerAccountEarnedFee` object types. All fields are combined with a logical ‘and.’ */
export type BrokerAccountEarnedFeeFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerAccountEarnedFeeFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `brokerAccountByBrokerAccountIdSs58` relation. */
  brokerAccountByBrokerAccountIdSs58?: InputMaybe<BrokerAccountFilter>;
  /** Filter by the object’s `brokerAccountIdSs58` field. */
  brokerAccountIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerAccountEarnedFeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerAccountEarnedFeeFilter>>;
};

export type BrokerAccountEarnedFeeMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
};

export type BrokerAccountEarnedFeeMaxAggregates = {
  __typename?: 'BrokerAccountEarnedFeeMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BrokerAccountEarnedFeeMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
};

export type BrokerAccountEarnedFeeMinAggregates = {
  __typename?: 'BrokerAccountEarnedFeeMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BrokerAccountEarnedFeeStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountEarnedFeeStddevPopulationAggregates = {
  __typename?: 'BrokerAccountEarnedFeeStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountEarnedFeeStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountEarnedFeeStddevSampleAggregates = {
  __typename?: 'BrokerAccountEarnedFeeStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountEarnedFeeSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BrokerAccountEarnedFeeSumAggregates = {
  __typename?: 'BrokerAccountEarnedFeeSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type BrokerAccountEarnedFeeVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountEarnedFeeVariancePopulationAggregates = {
  __typename?: 'BrokerAccountEarnedFeeVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountEarnedFeeVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountEarnedFeeVarianceSampleAggregates = {
  __typename?: 'BrokerAccountEarnedFeeVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerAccountEarnedFee` values. */
export type BrokerAccountEarnedFeesConnection = {
  __typename?: 'BrokerAccountEarnedFeesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerAccountEarnedFeeAggregates>;
  /** A list of edges which contains the `BrokerAccountEarnedFee` and cursor to aid in pagination. */
  edges: Array<BrokerAccountEarnedFeesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerAccountEarnedFeeAggregates>>;
  /** A list of `BrokerAccountEarnedFee` objects. */
  nodes: Array<BrokerAccountEarnedFee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerAccountEarnedFee` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerAccountEarnedFee` values. */
export type BrokerAccountEarnedFeesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerAccountEarnedFeesGroupBy>;
  having?: InputMaybe<BrokerAccountEarnedFeesHavingInput>;
};

/** A `BrokerAccountEarnedFee` edge in the connection. */
export type BrokerAccountEarnedFeesEdge = {
  __typename?: 'BrokerAccountEarnedFeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerAccountEarnedFee` at the end of the edge. */
  node: BrokerAccountEarnedFee;
};

/** Grouping methods for `BrokerAccountEarnedFee` for usage during aggregation. */
export type BrokerAccountEarnedFeesGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BROKER_ACCOUNT_ID_SS58'
  | 'CHAIN';

export type BrokerAccountEarnedFeesHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountEarnedFeesHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BrokerAccountEarnedFee` aggregates. */
export type BrokerAccountEarnedFeesHavingInput = {
  AND?: InputMaybe<Array<BrokerAccountEarnedFeesHavingInput>>;
  OR?: InputMaybe<Array<BrokerAccountEarnedFeesHavingInput>>;
  average?: InputMaybe<BrokerAccountEarnedFeesHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerAccountEarnedFeesHavingDistinctCountInput>;
  max?: InputMaybe<BrokerAccountEarnedFeesHavingMaxInput>;
  min?: InputMaybe<BrokerAccountEarnedFeesHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerAccountEarnedFeesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerAccountEarnedFeesHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerAccountEarnedFeesHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerAccountEarnedFeesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerAccountEarnedFeesHavingVarianceSampleInput>;
};

export type BrokerAccountEarnedFeesHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountEarnedFeesHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountEarnedFeesHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountEarnedFeesHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountEarnedFeesHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountEarnedFeesHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountEarnedFeesHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Methods to use when ordering `BrokerAccountEarnedFee`. */
export type BrokerAccountEarnedFeesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_ID_SS58_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** A filter to be used against `BrokerAccount` object types. All fields are combined with a logical ‘and.’ */
export type BrokerAccountFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerAccountFilter>>;
  /** Filter by the object’s `bondedFlipBalance` field. */
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `brokerAccountByDelegateBrokerId` relation. */
  brokerAccountByDelegateBrokerId?: InputMaybe<BrokerAccountFilter>;
  /** A related `brokerAccountByDelegateBrokerId` exists. */
  brokerAccountByDelegateBrokerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerAccountEarnedFeesByBrokerAccountIdSs58` relation. */
  brokerAccountEarnedFeesByBrokerAccountIdSs58?: InputMaybe<BrokerAccountToManyBrokerAccountEarnedFeeFilter>;
  /** Some related `brokerAccountEarnedFeesByBrokerAccountIdSs58` exist. */
  brokerAccountEarnedFeesByBrokerAccountIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerAccountsByDelegateBrokerId` relation. */
  brokerAccountsByDelegateBrokerId?: InputMaybe<BrokerAccountToManyBrokerAccountFilter>;
  /** Some related `brokerAccountsByDelegateBrokerId` exist. */
  brokerAccountsByDelegateBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerVaultDepositAddress` field. */
  brokerVaultDepositAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `delegateBrokerId` field. */
  delegateBrokerId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerAccountFilter>>;
  /** Filter by the object’s `registrationId` field. */
  registrationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `BrokerAccount` for usage during aggregation. */
export type BrokerAccountGroupBy =
  | 'ALIAS'
  | 'BONDED_FLIP_BALANCE'
  | 'BROKER_VAULT_DEPOSIT_ADDRESS'
  | 'DELEGATE_BROKER_ID'
  | 'FLIP_BALANCE'
  | 'REGISTRATION_ID'
  | 'WITHDRAWAL_ADDRESS';

export type BrokerAccountHavingAverageInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingDistinctCountInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BrokerAccount` aggregates. */
export type BrokerAccountHavingInput = {
  AND?: InputMaybe<Array<BrokerAccountHavingInput>>;
  OR?: InputMaybe<Array<BrokerAccountHavingInput>>;
  average?: InputMaybe<BrokerAccountHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerAccountHavingDistinctCountInput>;
  max?: InputMaybe<BrokerAccountHavingMaxInput>;
  min?: InputMaybe<BrokerAccountHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerAccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerAccountHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerAccountHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerAccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerAccountHavingVarianceSampleInput>;
};

export type BrokerAccountHavingMaxInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingMinInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingStddevPopulationInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingStddevSampleInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingSumInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingVariancePopulationInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountHavingVarianceSampleInput = {
  bondedFlipBalance?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
};

export type BrokerAccountMaxAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<IntFilter>;
};

export type BrokerAccountMaxAggregates = {
  __typename?: 'BrokerAccountMaxAggregates';
  /** Maximum of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['Int']['output']>;
};

export type BrokerAccountMinAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<IntFilter>;
};

export type BrokerAccountMinAggregates = {
  __typename?: 'BrokerAccountMinAggregates';
  /** Minimum of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['Int']['output']>;
};

export type BrokerAccountStddevPopulationAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountStddevPopulationAggregates = {
  __typename?: 'BrokerAccountStddevPopulationAggregates';
  /** Population standard deviation of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountStddevSampleAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountStddevSampleAggregates = {
  __typename?: 'BrokerAccountStddevSampleAggregates';
  /** Sample standard deviation of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountSumAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigIntFilter>;
};

export type BrokerAccountSumAggregates = {
  __typename?: 'BrokerAccountSumAggregates';
  /** Sum of bondedFlipBalance across the matching connection */
  bondedFlipBalance: Scalars['BigFloat']['output'];
  /** Sum of flipBalance across the matching connection */
  flipBalance: Scalars['BigFloat']['output'];
  /** Sum of registrationId across the matching connection */
  registrationId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `BrokerAccountEarnedFee` object types. All fields are combined with a logical ‘and.’ */
export type BrokerAccountToManyBrokerAccountEarnedFeeFilter = {
  /** Aggregates across related `BrokerAccountEarnedFee` match the filter criteria. */
  aggregates?: InputMaybe<BrokerAccountEarnedFeeAggregatesFilter>;
  /** Every related `BrokerAccountEarnedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerAccountEarnedFeeFilter>;
  /** No related `BrokerAccountEarnedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerAccountEarnedFeeFilter>;
  /** Some related `BrokerAccountEarnedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerAccountEarnedFeeFilter>;
};

/** A filter to be used against many `BrokerAccount` object types. All fields are combined with a logical ‘and.’ */
export type BrokerAccountToManyBrokerAccountFilter = {
  /** Aggregates across related `BrokerAccount` match the filter criteria. */
  aggregates?: InputMaybe<BrokerAccountAggregatesFilter>;
  /** Every related `BrokerAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerAccountFilter>;
  /** No related `BrokerAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerAccountFilter>;
  /** Some related `BrokerAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerAccountFilter>;
};

export type BrokerAccountVariancePopulationAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountVariancePopulationAggregates = {
  __typename?: 'BrokerAccountVariancePopulationAggregates';
  /** Population variance of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAccountVarianceSampleAggregateFilter = {
  bondedFlipBalance?: InputMaybe<BigFloatFilter>;
  flipBalance?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAccountVarianceSampleAggregates = {
  __typename?: 'BrokerAccountVarianceSampleAggregates';
  /** Sample variance of bondedFlipBalance across the matching connection */
  bondedFlipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerAccount` values. */
export type BrokerAccountsConnection = {
  __typename?: 'BrokerAccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerAccountAggregates>;
  /** A list of edges which contains the `BrokerAccount` and cursor to aid in pagination. */
  edges: Array<BrokerAccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerAccountAggregates>>;
  /** A list of `BrokerAccount` objects. */
  nodes: Array<BrokerAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerAccount` values. */
export type BrokerAccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerAccountGroupBy>;
  having?: InputMaybe<BrokerAccountHavingInput>;
};

/** A `BrokerAccount` edge in the connection. */
export type BrokerAccountsEdge = {
  __typename?: 'BrokerAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerAccount` at the end of the edge. */
  node: BrokerAccount;
};

/** Methods to use when ordering `BrokerAccount`. */
export type BrokerAccountsOrderBy =
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'BONDED_FLIP_BALANCE_ASC'
  | 'BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_AVERAGE_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_COUNT_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_COUNT_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MAX_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_MIN_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_SUM_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ALIAS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ALIAS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_BONDED_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_BONDED_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_DELEGATE_BROKER_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_DELEGATE_BROKER_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_FLIP_BALANCE_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_FLIP_BALANCE_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ID_SS58_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ID_SS58_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKER_ACCOUNTS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_AVERAGE_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_COUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_COUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MAX_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_MIN_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_SUM_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_ASSET_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_ASSET_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_BROKER_ACCOUNT_ID_SS58_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_BROKER_ACCOUNT_ID_SS58_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_CHAIN_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_CHAIN_DESC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_ACCOUNT_EARNED_FEES_BY_BROKER_ACCOUNT_ID_SS58_VARIANCE_SAMPLE_ID_DESC'
  | 'BROKER_VAULT_DEPOSIT_ADDRESS_ASC'
  | 'BROKER_VAULT_DEPOSIT_ADDRESS_DESC'
  | 'DELEGATE_BROKER_ID_ASC'
  | 'DELEGATE_BROKER_ID_DESC'
  | 'FLIP_BALANCE_ASC'
  | 'FLIP_BALANCE_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REGISTRATION_ID_ASC'
  | 'REGISTRATION_ID_DESC'
  | 'WITHDRAWAL_ADDRESS_ASC'
  | 'WITHDRAWAL_ADDRESS_DESC';

export type ChainflipAsset =
  | 'ArbEth'
  | 'ArbUsdc'
  | 'Btc'
  | 'Dot'
  | 'Eth'
  | 'Flip'
  | 'HubDot'
  | 'HubUsdc'
  | 'HubUsdt'
  | 'Sol'
  | 'SolUsdc'
  | 'Usdc'
  | 'Usdt';

/** A filter to be used against ChainflipAsset fields. All fields are combined with a logical ‘and.’ */
export type ChainflipAssetFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipAsset>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipAsset>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipAsset>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipAsset>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipAsset>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipAsset>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipAsset>>;
};

export type ChainflipChain =
  | 'Arbitrum'
  | 'Assethub'
  | 'Bitcoin'
  | 'Ethereum'
  | 'Polkadot'
  | 'Solana';

/** A filter to be used against ChainflipChain fields. All fields are combined with a logical ‘and.’ */
export type ChainflipChainFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipChain>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipChain>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipChain>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipChain>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipChain>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipChain>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipChain>>;
};

export type Circulation = Node & {
  __typename?: 'Circulation';
  circulatingSupply: Scalars['BigFloat']['output'];
  circulatingSupplyNotStaked: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  totalLocked: Scalars['BigFloat']['output'];
  totalStaked: Scalars['BigFloat']['output'];
  totalSupply: Scalars['BigFloat']['output'];
};

export type CirculationAggregates = {
  __typename?: 'CirculationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CirculationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CirculationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CirculationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CirculationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CirculationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CirculationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CirculationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CirculationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CirculationVarianceSampleAggregates>;
};

export type CirculationAverageAggregates = {
  __typename?: 'CirculationAverageAggregates';
  /** Mean average of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Circulation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CirculationCondition = {
  /** Checks for equality with the object’s `circulatingSupply` field. */
  circulatingSupply?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `circulatingSupplyNotStaked` field. */
  circulatingSupplyNotStaked?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `totalLocked` field. */
  totalLocked?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalStaked` field. */
  totalStaked?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalSupply` field. */
  totalSupply?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type CirculationDistinctCountAggregates = {
  __typename?: 'CirculationDistinctCountAggregates';
  /** Distinct count of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Circulation` object types. All fields are combined with a logical ‘and.’ */
export type CirculationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CirculationFilter>>;
  /** Filter by the object’s `circulatingSupply` field. */
  circulatingSupply?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `circulatingSupplyNotStaked` field. */
  circulatingSupplyNotStaked?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CirculationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CirculationFilter>>;
  /** Filter by the object’s `totalLocked` field. */
  totalLocked?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalStaked` field. */
  totalStaked?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalSupply` field. */
  totalSupply?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `Circulation` for usage during aggregation. */
export type CirculationGroupBy =
  | 'CIRCULATING_SUPPLY'
  | 'CIRCULATING_SUPPLY_NOT_STAKED'
  | 'TOTAL_LOCKED'
  | 'TOTAL_STAKED'
  | 'TOTAL_SUPPLY';

export type CirculationHavingAverageInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingDistinctCountInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Circulation` aggregates. */
export type CirculationHavingInput = {
  AND?: InputMaybe<Array<CirculationHavingInput>>;
  OR?: InputMaybe<Array<CirculationHavingInput>>;
  average?: InputMaybe<CirculationHavingAverageInput>;
  distinctCount?: InputMaybe<CirculationHavingDistinctCountInput>;
  max?: InputMaybe<CirculationHavingMaxInput>;
  min?: InputMaybe<CirculationHavingMinInput>;
  stddevPopulation?: InputMaybe<CirculationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CirculationHavingStddevSampleInput>;
  sum?: InputMaybe<CirculationHavingSumInput>;
  variancePopulation?: InputMaybe<CirculationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CirculationHavingVarianceSampleInput>;
};

export type CirculationHavingMaxInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingMinInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingStddevPopulationInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingStddevSampleInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingSumInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingVariancePopulationInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationHavingVarianceSampleInput = {
  circulatingSupply?: InputMaybe<HavingBigfloatFilter>;
  circulatingSupplyNotStaked?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  totalLocked?: InputMaybe<HavingBigfloatFilter>;
  totalStaked?: InputMaybe<HavingBigfloatFilter>;
  totalSupply?: InputMaybe<HavingBigfloatFilter>;
};

export type CirculationMaxAggregates = {
  __typename?: 'CirculationMaxAggregates';
  /** Maximum of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationMinAggregates = {
  __typename?: 'CirculationMinAggregates';
  /** Minimum of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationStddevPopulationAggregates = {
  __typename?: 'CirculationStddevPopulationAggregates';
  /** Population standard deviation of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationStddevSampleAggregates = {
  __typename?: 'CirculationStddevSampleAggregates';
  /** Sample standard deviation of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationSumAggregates = {
  __typename?: 'CirculationSumAggregates';
  /** Sum of circulatingSupply across the matching connection */
  circulatingSupply: Scalars['BigFloat']['output'];
  /** Sum of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of totalLocked across the matching connection */
  totalLocked: Scalars['BigFloat']['output'];
  /** Sum of totalStaked across the matching connection */
  totalStaked: Scalars['BigFloat']['output'];
  /** Sum of totalSupply across the matching connection */
  totalSupply: Scalars['BigFloat']['output'];
};

export type CirculationVariancePopulationAggregates = {
  __typename?: 'CirculationVariancePopulationAggregates';
  /** Population variance of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

export type CirculationVarianceSampleAggregates = {
  __typename?: 'CirculationVarianceSampleAggregates';
  /** Sample variance of circulatingSupply across the matching connection */
  circulatingSupply?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of circulatingSupplyNotStaked across the matching connection */
  circulatingSupplyNotStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalLocked across the matching connection */
  totalLocked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalStaked across the matching connection */
  totalStaked?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalSupply across the matching connection */
  totalSupply?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Circulation` values. */
export type CirculationsConnection = {
  __typename?: 'CirculationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CirculationAggregates>;
  /** A list of edges which contains the `Circulation` and cursor to aid in pagination. */
  edges: Array<CirculationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CirculationAggregates>>;
  /** A list of `Circulation` objects. */
  nodes: Array<Circulation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Circulation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Circulation` values. */
export type CirculationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<CirculationGroupBy>;
  having?: InputMaybe<CirculationHavingInput>;
};

/** A `Circulation` edge in the connection. */
export type CirculationsEdge = {
  __typename?: 'CirculationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Circulation` at the end of the edge. */
  node: Circulation;
};

/** Methods to use when ordering `Circulation`. */
export type CirculationsOrderBy =
  | 'CIRCULATING_SUPPLY_ASC'
  | 'CIRCULATING_SUPPLY_DESC'
  | 'CIRCULATING_SUPPLY_NOT_STAKED_ASC'
  | 'CIRCULATING_SUPPLY_NOT_STAKED_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TOTAL_LOCKED_ASC'
  | 'TOTAL_LOCKED_DESC'
  | 'TOTAL_STAKED_ASC'
  | 'TOTAL_STAKED_DESC'
  | 'TOTAL_SUPPLY_ASC'
  | 'TOTAL_SUPPLY_DESC';

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type DepositBalance = {
  __typename?: 'DepositBalance';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  chain: ChainflipChain;
  /** Reads a single `LpAccount` that is related to this `DepositBalance`. */
  lpAccountByLpIdSs58: LpAccount;
  lpIdSs58: Scalars['String']['output'];
  valueUsd: Scalars['BigFloat']['output'];
};

export type DepositBalanceAggregates = {
  __typename?: 'DepositBalanceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<DepositBalanceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DepositBalanceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<DepositBalanceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<DepositBalanceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<DepositBalanceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<DepositBalanceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<DepositBalanceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<DepositBalanceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<DepositBalanceVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `DepositBalance` object types. */
export type DepositBalanceAggregatesFilter = {
  /** Mean average aggregate over matching `DepositBalance` objects. */
  average?: InputMaybe<DepositBalanceAverageAggregateFilter>;
  /** Distinct count aggregate over matching `DepositBalance` objects. */
  distinctCount?: InputMaybe<DepositBalanceDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DepositBalance` object to be included within the aggregate. */
  filter?: InputMaybe<DepositBalanceFilter>;
  /** Maximum aggregate over matching `DepositBalance` objects. */
  max?: InputMaybe<DepositBalanceMaxAggregateFilter>;
  /** Minimum aggregate over matching `DepositBalance` objects. */
  min?: InputMaybe<DepositBalanceMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `DepositBalance` objects. */
  stddevPopulation?: InputMaybe<DepositBalanceStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `DepositBalance` objects. */
  stddevSample?: InputMaybe<DepositBalanceStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `DepositBalance` objects. */
  sum?: InputMaybe<DepositBalanceSumAggregateFilter>;
  /** Population variance aggregate over matching `DepositBalance` objects. */
  variancePopulation?: InputMaybe<DepositBalanceVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `DepositBalance` objects. */
  varianceSample?: InputMaybe<DepositBalanceVarianceSampleAggregateFilter>;
};

export type DepositBalanceAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceAverageAggregates = {
  __typename?: 'DepositBalanceAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `DepositBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DepositBalanceCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type DepositBalanceDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  lpIdSs58?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type DepositBalanceDistinctCountAggregates = {
  __typename?: 'DepositBalanceDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpIdSs58 across the matching connection */
  lpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `DepositBalance` object types. All fields are combined with a logical ‘and.’ */
export type DepositBalanceFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DepositBalanceFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `lpAccountByLpIdSs58` relation. */
  lpAccountByLpIdSs58?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DepositBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DepositBalanceFilter>>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `DepositBalance` for usage during aggregation. */
export type DepositBalanceGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'CHAIN'
  | 'LP_ID_SS58'
  | 'VALUE_USD';

export type DepositBalanceHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `DepositBalance` aggregates. */
export type DepositBalanceHavingInput = {
  AND?: InputMaybe<Array<DepositBalanceHavingInput>>;
  OR?: InputMaybe<Array<DepositBalanceHavingInput>>;
  average?: InputMaybe<DepositBalanceHavingAverageInput>;
  distinctCount?: InputMaybe<DepositBalanceHavingDistinctCountInput>;
  max?: InputMaybe<DepositBalanceHavingMaxInput>;
  min?: InputMaybe<DepositBalanceHavingMinInput>;
  stddevPopulation?: InputMaybe<DepositBalanceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DepositBalanceHavingStddevSampleInput>;
  sum?: InputMaybe<DepositBalanceHavingSumInput>;
  variancePopulation?: InputMaybe<DepositBalanceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DepositBalanceHavingVarianceSampleInput>;
};

export type DepositBalanceHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DepositBalanceMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceMaxAggregates = {
  __typename?: 'DepositBalanceMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceMinAggregates = {
  __typename?: 'DepositBalanceMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceStddevPopulationAggregates = {
  __typename?: 'DepositBalanceStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceStddevSampleAggregates = {
  __typename?: 'DepositBalanceStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceSumAggregates = {
  __typename?: 'DepositBalanceSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type DepositBalanceVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceVariancePopulationAggregates = {
  __typename?: 'DepositBalanceVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositBalanceVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DepositBalanceVarianceSampleAggregates = {
  __typename?: 'DepositBalanceVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `DepositBalance` values. */
export type DepositBalancesConnection = {
  __typename?: 'DepositBalancesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DepositBalanceAggregates>;
  /** A list of edges which contains the `DepositBalance` and cursor to aid in pagination. */
  edges: Array<DepositBalancesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DepositBalanceAggregates>>;
  /** A list of `DepositBalance` objects. */
  nodes: Array<DepositBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DepositBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `DepositBalance` values. */
export type DepositBalancesConnectionGroupedAggregatesArgs = {
  groupBy: Array<DepositBalanceGroupBy>;
  having?: InputMaybe<DepositBalanceHavingInput>;
};

/** A `DepositBalance` edge in the connection. */
export type DepositBalancesEdge = {
  __typename?: 'DepositBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DepositBalance` at the end of the edge. */
  node: DepositBalance;
};

/** Methods to use when ordering `DepositBalance`. */
export type DepositBalancesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'LP_ID_SS58_ASC'
  | 'LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type EnvironmentAddress = Node & {
  __typename?: 'EnvironmentAddress';
  id: Scalars['Int']['output'];
  keyManagerAddress: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  redemptionTax: Scalars['BigFloat']['output'];
  runtimeVersion: Scalars['Int']['output'];
  stateChainGatewayAddress: Scalars['String']['output'];
};

export type EnvironmentAddressAggregates = {
  __typename?: 'EnvironmentAddressAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EnvironmentAddressAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EnvironmentAddressDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EnvironmentAddressMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EnvironmentAddressMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EnvironmentAddressStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EnvironmentAddressStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EnvironmentAddressSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EnvironmentAddressVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EnvironmentAddressVarianceSampleAggregates>;
};

export type EnvironmentAddressAverageAggregates = {
  __typename?: 'EnvironmentAddressAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `EnvironmentAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EnvironmentAddressCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `keyManagerAddress` field. */
  keyManagerAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `redemptionTax` field. */
  redemptionTax?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `runtimeVersion` field. */
  runtimeVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stateChainGatewayAddress` field. */
  stateChainGatewayAddress?: InputMaybe<Scalars['String']['input']>;
};

export type EnvironmentAddressDistinctCountAggregates = {
  __typename?: 'EnvironmentAddressDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of keyManagerAddress across the matching connection */
  keyManagerAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateChainGatewayAddress across the matching connection */
  stateChainGatewayAddress?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `EnvironmentAddress` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentAddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentAddressFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `keyManagerAddress` field. */
  keyManagerAddress?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentAddressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentAddressFilter>>;
  /** Filter by the object’s `redemptionTax` field. */
  redemptionTax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `runtimeVersion` field. */
  runtimeVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stateChainGatewayAddress` field. */
  stateChainGatewayAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `EnvironmentAddress` for usage during aggregation. */
export type EnvironmentAddressGroupBy =
  | 'KEY_MANAGER_ADDRESS'
  | 'REDEMPTION_TAX'
  | 'RUNTIME_VERSION'
  | 'STATE_CHAIN_GATEWAY_ADDRESS';

export type EnvironmentAddressHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `EnvironmentAddress` aggregates. */
export type EnvironmentAddressHavingInput = {
  AND?: InputMaybe<Array<EnvironmentAddressHavingInput>>;
  OR?: InputMaybe<Array<EnvironmentAddressHavingInput>>;
  average?: InputMaybe<EnvironmentAddressHavingAverageInput>;
  distinctCount?: InputMaybe<EnvironmentAddressHavingDistinctCountInput>;
  max?: InputMaybe<EnvironmentAddressHavingMaxInput>;
  min?: InputMaybe<EnvironmentAddressHavingMinInput>;
  stddevPopulation?: InputMaybe<EnvironmentAddressHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EnvironmentAddressHavingStddevSampleInput>;
  sum?: InputMaybe<EnvironmentAddressHavingSumInput>;
  variancePopulation?: InputMaybe<EnvironmentAddressHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EnvironmentAddressHavingVarianceSampleInput>;
};

export type EnvironmentAddressHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  redemptionTax?: InputMaybe<HavingBigfloatFilter>;
  runtimeVersion?: InputMaybe<HavingIntFilter>;
};

export type EnvironmentAddressMaxAggregates = {
  __typename?: 'EnvironmentAddressMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['Int']['output']>;
};

export type EnvironmentAddressMinAggregates = {
  __typename?: 'EnvironmentAddressMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['Int']['output']>;
};

export type EnvironmentAddressStddevPopulationAggregates = {
  __typename?: 'EnvironmentAddressStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

export type EnvironmentAddressStddevSampleAggregates = {
  __typename?: 'EnvironmentAddressStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

export type EnvironmentAddressSumAggregates = {
  __typename?: 'EnvironmentAddressSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of redemptionTax across the matching connection */
  redemptionTax: Scalars['BigFloat']['output'];
  /** Sum of runtimeVersion across the matching connection */
  runtimeVersion: Scalars['BigInt']['output'];
};

export type EnvironmentAddressVariancePopulationAggregates = {
  __typename?: 'EnvironmentAddressVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

export type EnvironmentAddressVarianceSampleAggregates = {
  __typename?: 'EnvironmentAddressVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of redemptionTax across the matching connection */
  redemptionTax?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of runtimeVersion across the matching connection */
  runtimeVersion?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `EnvironmentAddress` values. */
export type EnvironmentAddressesConnection = {
  __typename?: 'EnvironmentAddressesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EnvironmentAddressAggregates>;
  /** A list of edges which contains the `EnvironmentAddress` and cursor to aid in pagination. */
  edges: Array<EnvironmentAddressesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EnvironmentAddressAggregates>>;
  /** A list of `EnvironmentAddress` objects. */
  nodes: Array<EnvironmentAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EnvironmentAddress` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `EnvironmentAddress` values. */
export type EnvironmentAddressesConnectionGroupedAggregatesArgs = {
  groupBy: Array<EnvironmentAddressGroupBy>;
  having?: InputMaybe<EnvironmentAddressHavingInput>;
};

/** A `EnvironmentAddress` edge in the connection. */
export type EnvironmentAddressesEdge = {
  __typename?: 'EnvironmentAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentAddress` at the end of the edge. */
  node: EnvironmentAddress;
};

/** Methods to use when ordering `EnvironmentAddress`. */
export type EnvironmentAddressesOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'KEY_MANAGER_ADDRESS_ASC'
  | 'KEY_MANAGER_ADDRESS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REDEMPTION_TAX_ASC'
  | 'REDEMPTION_TAX_DESC'
  | 'RUNTIME_VERSION_ASC'
  | 'RUNTIME_VERSION_DESC'
  | 'STATE_CHAIN_GATEWAY_ADDRESS_ASC'
  | 'STATE_CHAIN_GATEWAY_ADDRESS_DESC';

/** A connection to a list of `FlipSupply` values. */
export type FlipSuppliesConnection = {
  __typename?: 'FlipSuppliesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<FlipSupplyAggregates>;
  /** A list of edges which contains the `FlipSupply` and cursor to aid in pagination. */
  edges: Array<FlipSuppliesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<FlipSupplyAggregates>>;
  /** A list of `FlipSupply` objects. */
  nodes: Array<FlipSupply>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FlipSupply` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `FlipSupply` values. */
export type FlipSuppliesConnectionGroupedAggregatesArgs = {
  groupBy: Array<FlipSupplyGroupBy>;
  having?: InputMaybe<FlipSupplyHavingInput>;
};

/** A `FlipSupply` edge in the connection. */
export type FlipSuppliesEdge = {
  __typename?: 'FlipSuppliesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FlipSupply` at the end of the edge. */
  node: FlipSupply;
};

/** Methods to use when ordering `FlipSupply`. */
export type FlipSuppliesOrderBy =
  | 'ANNUAL_SYSTEM_COMPOUNDED_REWARDS_ASC'
  | 'ANNUAL_SYSTEM_COMPOUNDED_REWARDS_DESC'
  | 'AUTHORITY_EMISSION_PER_BLOCK_ASC'
  | 'AUTHORITY_EMISSION_PER_BLOCK_DESC'
  | 'BACKUP_NODE_EMISSION_PER_BLOCK_ASC'
  | 'BACKUP_NODE_EMISSION_PER_BLOCK_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OFFCHAIN_FUNDS_ASC'
  | 'OFFCHAIN_FUNDS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_BLOCK_HEIGHT_ASC'
  | 'START_BLOCK_HEIGHT_DESC'
  | 'START_BLOCK_TIMESTAMP_ASC'
  | 'START_BLOCK_TIMESTAMP_DESC'
  | 'TOTAL_ANNUAL_EMISSION_ASC'
  | 'TOTAL_ANNUAL_EMISSION_DESC'
  | 'TOTAL_ISSUANCE_ASC'
  | 'TOTAL_ISSUANCE_DESC';

export type FlipSupply = Node & {
  __typename?: 'FlipSupply';
  annualSystemCompoundedRewards: Scalars['String']['output'];
  authorityEmissionPerBlock: Scalars['BigFloat']['output'];
  backupNodeEmissionPerBlock: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  offchainFunds: Scalars['String']['output'];
  startBlockHeight: Scalars['Int']['output'];
  startBlockTimestamp: Scalars['BigInt']['output'];
  totalAnnualEmission: Scalars['BigFloat']['output'];
  totalIssuance: Scalars['String']['output'];
};

export type FlipSupplyAggregates = {
  __typename?: 'FlipSupplyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<FlipSupplyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<FlipSupplyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<FlipSupplyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<FlipSupplyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<FlipSupplyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<FlipSupplyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<FlipSupplySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<FlipSupplyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<FlipSupplyVarianceSampleAggregates>;
};

export type FlipSupplyAverageAggregates = {
  __typename?: 'FlipSupplyAverageAggregates';
  /** Mean average of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `FlipSupply` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FlipSupplyCondition = {
  /** Checks for equality with the object’s `annualSystemCompoundedRewards` field. */
  annualSystemCompoundedRewards?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `authorityEmissionPerBlock` field. */
  authorityEmissionPerBlock?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `backupNodeEmissionPerBlock` field. */
  backupNodeEmissionPerBlock?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `offchainFunds` field. */
  offchainFunds?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startBlockHeight` field. */
  startBlockHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startBlockTimestamp` field. */
  startBlockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalAnnualEmission` field. */
  totalAnnualEmission?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalIssuance` field. */
  totalIssuance?: InputMaybe<Scalars['String']['input']>;
};

export type FlipSupplyDistinctCountAggregates = {
  __typename?: 'FlipSupplyDistinctCountAggregates';
  /** Distinct count of annualSystemCompoundedRewards across the matching connection */
  annualSystemCompoundedRewards?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of offchainFunds across the matching connection */
  offchainFunds?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalIssuance across the matching connection */
  totalIssuance?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `FlipSupply` object types. All fields are combined with a logical ‘and.’ */
export type FlipSupplyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FlipSupplyFilter>>;
  /** Filter by the object’s `annualSystemCompoundedRewards` field. */
  annualSystemCompoundedRewards?: InputMaybe<StringFilter>;
  /** Filter by the object’s `authorityEmissionPerBlock` field. */
  authorityEmissionPerBlock?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `backupNodeEmissionPerBlock` field. */
  backupNodeEmissionPerBlock?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FlipSupplyFilter>;
  /** Filter by the object’s `offchainFunds` field. */
  offchainFunds?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FlipSupplyFilter>>;
  /** Filter by the object’s `startBlockHeight` field. */
  startBlockHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startBlockTimestamp` field. */
  startBlockTimestamp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalAnnualEmission` field. */
  totalAnnualEmission?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalIssuance` field. */
  totalIssuance?: InputMaybe<StringFilter>;
};

/** Grouping methods for `FlipSupply` for usage during aggregation. */
export type FlipSupplyGroupBy =
  | 'ANNUAL_SYSTEM_COMPOUNDED_REWARDS'
  | 'AUTHORITY_EMISSION_PER_BLOCK'
  | 'BACKUP_NODE_EMISSION_PER_BLOCK'
  | 'OFFCHAIN_FUNDS'
  | 'START_BLOCK_HEIGHT'
  | 'START_BLOCK_TIMESTAMP'
  | 'TOTAL_ANNUAL_EMISSION'
  | 'TOTAL_ISSUANCE';

export type FlipSupplyHavingAverageInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingDistinctCountInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `FlipSupply` aggregates. */
export type FlipSupplyHavingInput = {
  AND?: InputMaybe<Array<FlipSupplyHavingInput>>;
  OR?: InputMaybe<Array<FlipSupplyHavingInput>>;
  average?: InputMaybe<FlipSupplyHavingAverageInput>;
  distinctCount?: InputMaybe<FlipSupplyHavingDistinctCountInput>;
  max?: InputMaybe<FlipSupplyHavingMaxInput>;
  min?: InputMaybe<FlipSupplyHavingMinInput>;
  stddevPopulation?: InputMaybe<FlipSupplyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<FlipSupplyHavingStddevSampleInput>;
  sum?: InputMaybe<FlipSupplyHavingSumInput>;
  variancePopulation?: InputMaybe<FlipSupplyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<FlipSupplyHavingVarianceSampleInput>;
};

export type FlipSupplyHavingMaxInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingMinInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingStddevPopulationInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingStddevSampleInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingSumInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingVariancePopulationInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyHavingVarianceSampleInput = {
  authorityEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  backupNodeEmissionPerBlock?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  startBlockHeight?: InputMaybe<HavingIntFilter>;
  startBlockTimestamp?: InputMaybe<HavingBigintFilter>;
  totalAnnualEmission?: InputMaybe<HavingBigfloatFilter>;
};

export type FlipSupplyMaxAggregates = {
  __typename?: 'FlipSupplyMaxAggregates';
  /** Maximum of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyMinAggregates = {
  __typename?: 'FlipSupplyMinAggregates';
  /** Minimum of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyStddevPopulationAggregates = {
  __typename?: 'FlipSupplyStddevPopulationAggregates';
  /** Population standard deviation of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyStddevSampleAggregates = {
  __typename?: 'FlipSupplyStddevSampleAggregates';
  /** Sample standard deviation of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplySumAggregates = {
  __typename?: 'FlipSupplySumAggregates';
  /** Sum of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock: Scalars['BigFloat']['output'];
  /** Sum of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of startBlockHeight across the matching connection */
  startBlockHeight: Scalars['BigInt']['output'];
  /** Sum of startBlockTimestamp across the matching connection */
  startBlockTimestamp: Scalars['BigFloat']['output'];
  /** Sum of totalAnnualEmission across the matching connection */
  totalAnnualEmission: Scalars['BigFloat']['output'];
};

export type FlipSupplyVariancePopulationAggregates = {
  __typename?: 'FlipSupplyVariancePopulationAggregates';
  /** Population variance of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

export type FlipSupplyVarianceSampleAggregates = {
  __typename?: 'FlipSupplyVarianceSampleAggregates';
  /** Sample variance of authorityEmissionPerBlock across the matching connection */
  authorityEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of backupNodeEmissionPerBlock across the matching connection */
  backupNodeEmissionPerBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockHeight across the matching connection */
  startBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockTimestamp across the matching connection */
  startBlockTimestamp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAnnualEmission across the matching connection */
  totalAnnualEmission?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type HavingBigfloatFilter = {
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type LpAccount = Node & {
  __typename?: 'LpAccount';
  alias?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `BoostBalance`. */
  boostBalancesByLpIdSs58: BoostBalancesConnection;
  /** Reads and enables pagination through a set of `DepositBalance`. */
  depositBalancesByLpIdSs58: DepositBalancesConnection;
  earnedFeesValueUsd: Scalars['BigFloat']['output'];
  flipBalance: Scalars['BigFloat']['output'];
  idSs58: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `LpTotalBalance`. */
  lpTotalBalancesByLpIdSs58: LpTotalBalancesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openOrders: Scalars['JSON']['output'];
};


export type LpAccountBoostBalancesByLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostBalanceCondition>;
  filter?: InputMaybe<BoostBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostBalancesOrderBy>>;
};


export type LpAccountDepositBalancesByLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositBalanceCondition>;
  filter?: InputMaybe<DepositBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositBalancesOrderBy>>;
};


export type LpAccountLpTotalBalancesByLpIdSs58Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpTotalBalanceCondition>;
  filter?: InputMaybe<LpTotalBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpTotalBalancesOrderBy>>;
};

export type LpAccountAggregates = {
  __typename?: 'LpAccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpAccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpAccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpAccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpAccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpAccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpAccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpAccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpAccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpAccountVarianceSampleAggregates>;
};

export type LpAccountAverageAggregates = {
  __typename?: 'LpAccountAverageAggregates';
  /** Mean average of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpAccount` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LpAccountCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `earnedFeesValueUsd` field. */
  earnedFeesValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `openOrders` field. */
  openOrders?: InputMaybe<Scalars['JSON']['input']>;
};

export type LpAccountDistinctCountAggregates = {
  __typename?: 'LpAccountDistinctCountAggregates';
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openOrders across the matching connection */
  openOrders?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpAccount` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpAccountFilter>>;
  /** Filter by the object’s `boostBalancesByLpIdSs58` relation. */
  boostBalancesByLpIdSs58?: InputMaybe<LpAccountToManyBoostBalanceFilter>;
  /** Some related `boostBalancesByLpIdSs58` exist. */
  boostBalancesByLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `depositBalancesByLpIdSs58` relation. */
  depositBalancesByLpIdSs58?: InputMaybe<LpAccountToManyDepositBalanceFilter>;
  /** Some related `depositBalancesByLpIdSs58` exist. */
  depositBalancesByLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `earnedFeesValueUsd` field. */
  earnedFeesValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `flipBalance` field. */
  flipBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lpTotalBalancesByLpIdSs58` relation. */
  lpTotalBalancesByLpIdSs58?: InputMaybe<LpAccountToManyLpTotalBalanceFilter>;
  /** Some related `lpTotalBalancesByLpIdSs58` exist. */
  lpTotalBalancesByLpIdSs58Exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `openOrders` field. */
  openOrders?: InputMaybe<JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpAccountFilter>>;
};

/** Grouping methods for `LpAccount` for usage during aggregation. */
export type LpAccountGroupBy =
  | 'ALIAS'
  | 'EARNED_FEES_VALUE_USD'
  | 'FLIP_BALANCE'
  | 'OPEN_ORDERS';

export type LpAccountHavingAverageInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingDistinctCountInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpAccount` aggregates. */
export type LpAccountHavingInput = {
  AND?: InputMaybe<Array<LpAccountHavingInput>>;
  OR?: InputMaybe<Array<LpAccountHavingInput>>;
  average?: InputMaybe<LpAccountHavingAverageInput>;
  distinctCount?: InputMaybe<LpAccountHavingDistinctCountInput>;
  max?: InputMaybe<LpAccountHavingMaxInput>;
  min?: InputMaybe<LpAccountHavingMinInput>;
  stddevPopulation?: InputMaybe<LpAccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpAccountHavingStddevSampleInput>;
  sum?: InputMaybe<LpAccountHavingSumInput>;
  variancePopulation?: InputMaybe<LpAccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpAccountHavingVarianceSampleInput>;
};

export type LpAccountHavingMaxInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingMinInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingStddevPopulationInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingStddevSampleInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingSumInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingVariancePopulationInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountHavingVarianceSampleInput = {
  earnedFeesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  flipBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type LpAccountMaxAggregates = {
  __typename?: 'LpAccountMaxAggregates';
  /** Maximum of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountMinAggregates = {
  __typename?: 'LpAccountMinAggregates';
  /** Minimum of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountStddevPopulationAggregates = {
  __typename?: 'LpAccountStddevPopulationAggregates';
  /** Population standard deviation of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountStddevSampleAggregates = {
  __typename?: 'LpAccountStddevSampleAggregates';
  /** Sample standard deviation of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountSumAggregates = {
  __typename?: 'LpAccountSumAggregates';
  /** Sum of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd: Scalars['BigFloat']['output'];
  /** Sum of flipBalance across the matching connection */
  flipBalance: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `BoostBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountToManyBoostBalanceFilter = {
  /** Aggregates across related `BoostBalance` match the filter criteria. */
  aggregates?: InputMaybe<BoostBalanceAggregatesFilter>;
  /** Every related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostBalanceFilter>;
  /** No related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostBalanceFilter>;
  /** Some related `BoostBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostBalanceFilter>;
};

/** A filter to be used against many `DepositBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountToManyDepositBalanceFilter = {
  /** Aggregates across related `DepositBalance` match the filter criteria. */
  aggregates?: InputMaybe<DepositBalanceAggregatesFilter>;
  /** Every related `DepositBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepositBalanceFilter>;
  /** No related `DepositBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepositBalanceFilter>;
  /** Some related `DepositBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepositBalanceFilter>;
};

/** A filter to be used against many `LpTotalBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpAccountToManyLpTotalBalanceFilter = {
  /** Aggregates across related `LpTotalBalance` match the filter criteria. */
  aggregates?: InputMaybe<LpTotalBalanceAggregatesFilter>;
  /** Every related `LpTotalBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LpTotalBalanceFilter>;
  /** No related `LpTotalBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LpTotalBalanceFilter>;
  /** Some related `LpTotalBalance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LpTotalBalanceFilter>;
};

export type LpAccountVariancePopulationAggregates = {
  __typename?: 'LpAccountVariancePopulationAggregates';
  /** Population variance of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpAccountVarianceSampleAggregates = {
  __typename?: 'LpAccountVarianceSampleAggregates';
  /** Sample variance of earnedFeesValueUsd across the matching connection */
  earnedFeesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of flipBalance across the matching connection */
  flipBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpAccount` values. */
export type LpAccountsConnection = {
  __typename?: 'LpAccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpAccountAggregates>;
  /** A list of edges which contains the `LpAccount` and cursor to aid in pagination. */
  edges: Array<LpAccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpAccountAggregates>>;
  /** A list of `LpAccount` objects. */
  nodes: Array<LpAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpAccount` values. */
export type LpAccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpAccountGroupBy>;
  having?: InputMaybe<LpAccountHavingInput>;
};

/** A `LpAccount` edge in the connection. */
export type LpAccountsEdge = {
  __typename?: 'LpAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpAccount` at the end of the edge. */
  node: LpAccount;
};

/** Methods to use when ordering `LpAccount`. */
export type LpAccountsOrderBy =
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_AVERAGE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_COUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_COUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MAX_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_MIN_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_SUM_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LP_ID_SS58_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LP_ID_SS58_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_ID_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_ID_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_SHARE_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_POOL_SHARE_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_DESC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_ASC'
  | 'BOOST_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UNAVAILABLE_AMOUNT_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_AVERAGE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_COUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_COUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MAX_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_MIN_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_SUM_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ASSET_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ASSET_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_CHAIN_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_CHAIN_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LP_ID_SS58_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LP_ID_SS58_DESC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'DEPOSIT_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'EARNED_FEES_VALUE_USD_ASC'
  | 'EARNED_FEES_VALUE_USD_DESC'
  | 'FLIP_BALANCE_ASC'
  | 'FLIP_BALANCE_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_AVERAGE_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_COUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_COUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MAX_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_MIN_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_SUM_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ASSET_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_ASSET_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_CHAIN_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_CHAIN_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LP_ID_SS58_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_LP_ID_SS58_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LP_TOTAL_BALANCES_BY_LP_ID_SS58_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'NATURAL'
  | 'OPEN_ORDERS_ASC'
  | 'OPEN_ORDERS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type LpTotalBalance = {
  __typename?: 'LpTotalBalance';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  chain: ChainflipChain;
  createdAt: Scalars['Datetime']['output'];
  /** Reads a single `LpAccount` that is related to this `LpTotalBalance`. */
  lpAccountByLpIdSs58: LpAccount;
  lpIdSs58: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  valueUsd: Scalars['BigFloat']['output'];
};

export type LpTotalBalanceAggregates = {
  __typename?: 'LpTotalBalanceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LpTotalBalanceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LpTotalBalanceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LpTotalBalanceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LpTotalBalanceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LpTotalBalanceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LpTotalBalanceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LpTotalBalanceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LpTotalBalanceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LpTotalBalanceVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LpTotalBalance` object types. */
export type LpTotalBalanceAggregatesFilter = {
  /** Mean average aggregate over matching `LpTotalBalance` objects. */
  average?: InputMaybe<LpTotalBalanceAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LpTotalBalance` objects. */
  distinctCount?: InputMaybe<LpTotalBalanceDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LpTotalBalance` object to be included within the aggregate. */
  filter?: InputMaybe<LpTotalBalanceFilter>;
  /** Maximum aggregate over matching `LpTotalBalance` objects. */
  max?: InputMaybe<LpTotalBalanceMaxAggregateFilter>;
  /** Minimum aggregate over matching `LpTotalBalance` objects. */
  min?: InputMaybe<LpTotalBalanceMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LpTotalBalance` objects. */
  stddevPopulation?: InputMaybe<LpTotalBalanceStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LpTotalBalance` objects. */
  stddevSample?: InputMaybe<LpTotalBalanceStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LpTotalBalance` objects. */
  sum?: InputMaybe<LpTotalBalanceSumAggregateFilter>;
  /** Population variance aggregate over matching `LpTotalBalance` objects. */
  variancePopulation?: InputMaybe<LpTotalBalanceVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LpTotalBalance` objects. */
  varianceSample?: InputMaybe<LpTotalBalanceVarianceSampleAggregateFilter>;
};

export type LpTotalBalanceAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceAverageAggregates = {
  __typename?: 'LpTotalBalanceAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LpTotalBalance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LpTotalBalanceCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LpTotalBalanceDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  lpIdSs58?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type LpTotalBalanceDistinctCountAggregates = {
  __typename?: 'LpTotalBalanceDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lpIdSs58 across the matching connection */
  lpIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LpTotalBalance` object types. All fields are combined with a logical ‘and.’ */
export type LpTotalBalanceFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LpTotalBalanceFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lpAccountByLpIdSs58` relation. */
  lpAccountByLpIdSs58?: InputMaybe<LpAccountFilter>;
  /** Filter by the object’s `lpIdSs58` field. */
  lpIdSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LpTotalBalanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LpTotalBalanceFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LpTotalBalance` for usage during aggregation. */
export type LpTotalBalanceGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'CHAIN'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'LP_ID_SS58'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'VALUE_USD';

export type LpTotalBalanceHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LpTotalBalance` aggregates. */
export type LpTotalBalanceHavingInput = {
  AND?: InputMaybe<Array<LpTotalBalanceHavingInput>>;
  OR?: InputMaybe<Array<LpTotalBalanceHavingInput>>;
  average?: InputMaybe<LpTotalBalanceHavingAverageInput>;
  distinctCount?: InputMaybe<LpTotalBalanceHavingDistinctCountInput>;
  max?: InputMaybe<LpTotalBalanceHavingMaxInput>;
  min?: InputMaybe<LpTotalBalanceHavingMinInput>;
  stddevPopulation?: InputMaybe<LpTotalBalanceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LpTotalBalanceHavingStddevSampleInput>;
  sum?: InputMaybe<LpTotalBalanceHavingSumInput>;
  variancePopulation?: InputMaybe<LpTotalBalanceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LpTotalBalanceHavingVarianceSampleInput>;
};

export type LpTotalBalanceHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LpTotalBalanceMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceMaxAggregates = {
  __typename?: 'LpTotalBalanceMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpTotalBalanceMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceMinAggregates = {
  __typename?: 'LpTotalBalanceMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpTotalBalanceStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceStddevPopulationAggregates = {
  __typename?: 'LpTotalBalanceStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpTotalBalanceStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceStddevSampleAggregates = {
  __typename?: 'LpTotalBalanceStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpTotalBalanceSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceSumAggregates = {
  __typename?: 'LpTotalBalanceSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type LpTotalBalanceVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceVariancePopulationAggregates = {
  __typename?: 'LpTotalBalanceVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LpTotalBalanceVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LpTotalBalanceVarianceSampleAggregates = {
  __typename?: 'LpTotalBalanceVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LpTotalBalance` values. */
export type LpTotalBalancesConnection = {
  __typename?: 'LpTotalBalancesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LpTotalBalanceAggregates>;
  /** A list of edges which contains the `LpTotalBalance` and cursor to aid in pagination. */
  edges: Array<LpTotalBalancesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LpTotalBalanceAggregates>>;
  /** A list of `LpTotalBalance` objects. */
  nodes: Array<LpTotalBalance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LpTotalBalance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LpTotalBalance` values. */
export type LpTotalBalancesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LpTotalBalanceGroupBy>;
  having?: InputMaybe<LpTotalBalanceHavingInput>;
};

/** A `LpTotalBalance` edge in the connection. */
export type LpTotalBalancesEdge = {
  __typename?: 'LpTotalBalancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LpTotalBalance` at the end of the edge. */
  node: LpTotalBalance;
};

/** Methods to use when ordering `LpTotalBalance`. */
export type LpTotalBalancesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'LP_ID_SS58_ASC'
  | 'LP_ID_SS58_DESC'
  | 'NATURAL'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PendingDeposit = {
  __typename?: 'PendingDeposit';
  amount: Scalars['String']['output'];
  confirmations: Scalars['Int']['output'];
  txRef?: Maybe<Scalars['String']['output']>;
};

export type PendingDepositsInput = {
  address: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  chain: Scalars['String']['input'];
};

export type Pool = Node & {
  __typename?: 'Pool';
  baseAsset: ChainflipAsset;
  baseLiquidityAmount: Scalars['BigFloat']['output'];
  buyPrice: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  liquidityFeeHundredthPips: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openOrders?: Maybe<Scalars['JSON']['output']>;
  price: Scalars['Float']['output'];
  quoteAsset: ChainflipAsset;
  quoteLiquidityAmount: Scalars['BigFloat']['output'];
  rangeOrderPrice: Scalars['Float']['output'];
  sellPrice: Scalars['Float']['output'];
};

export type PoolAggregates = {
  __typename?: 'PoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PoolVarianceSampleAggregates>;
};

export type PoolAverageAggregates = {
  __typename?: 'PoolAverageAggregates';
  /** Mean average of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Mean average of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Mean average of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

/** A condition to be used against `Pool` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PoolCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseLiquidityAmount` field. */
  baseLiquidityAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `buyPrice` field. */
  buyPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityFeeHundredthPips` field. */
  liquidityFeeHundredthPips?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `openOrders` field. */
  openOrders?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `quoteLiquidityAmount` field. */
  quoteLiquidityAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rangeOrderPrice` field. */
  rangeOrderPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `sellPrice` field. */
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PoolDistinctCountAggregates = {
  __typename?: 'PoolDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openOrders across the matching connection */
  openOrders?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Pool` object types. All fields are combined with a logical ‘and.’ */
export type PoolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PoolFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseLiquidityAmount` field. */
  baseLiquidityAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `buyPrice` field. */
  buyPrice?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityFeeHundredthPips` field. */
  liquidityFeeHundredthPips?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PoolFilter>;
  /** Filter by the object’s `openOrders` field. */
  openOrders?: InputMaybe<JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PoolFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `quoteLiquidityAmount` field. */
  quoteLiquidityAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rangeOrderPrice` field. */
  rangeOrderPrice?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `sellPrice` field. */
  sellPrice?: InputMaybe<FloatFilter>;
};

/** Grouping methods for `Pool` for usage during aggregation. */
export type PoolGroupBy =
  | 'BASE_ASSET'
  | 'BASE_LIQUIDITY_AMOUNT'
  | 'BUY_PRICE'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS'
  | 'OPEN_ORDERS'
  | 'PRICE'
  | 'QUOTE_ASSET'
  | 'QUOTE_LIQUIDITY_AMOUNT'
  | 'RANGE_ORDER_PRICE'
  | 'SELL_PRICE';

export type PoolHavingAverageInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingDistinctCountInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

/** Conditions for `Pool` aggregates. */
export type PoolHavingInput = {
  AND?: InputMaybe<Array<PoolHavingInput>>;
  OR?: InputMaybe<Array<PoolHavingInput>>;
  average?: InputMaybe<PoolHavingAverageInput>;
  distinctCount?: InputMaybe<PoolHavingDistinctCountInput>;
  max?: InputMaybe<PoolHavingMaxInput>;
  min?: InputMaybe<PoolHavingMinInput>;
  stddevPopulation?: InputMaybe<PoolHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PoolHavingStddevSampleInput>;
  sum?: InputMaybe<PoolHavingSumInput>;
  variancePopulation?: InputMaybe<PoolHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PoolHavingVarianceSampleInput>;
};

export type PoolHavingMaxInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingMinInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingStddevPopulationInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingStddevSampleInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingSumInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingVariancePopulationInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolHavingVarianceSampleInput = {
  baseLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  buyPrice?: InputMaybe<HavingFloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  quoteLiquidityAmount?: InputMaybe<HavingBigfloatFilter>;
  rangeOrderPrice?: InputMaybe<HavingFloatFilter>;
  sellPrice?: InputMaybe<HavingFloatFilter>;
};

export type PoolMaxAggregates = {
  __typename?: 'PoolMaxAggregates';
  /** Maximum of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['Int']['output']>;
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Maximum of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Maximum of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolMinAggregates = {
  __typename?: 'PoolMinAggregates';
  /** Minimum of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['Int']['output']>;
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Minimum of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Minimum of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolStddevPopulationAggregates = {
  __typename?: 'PoolStddevPopulationAggregates';
  /** Population standard deviation of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolStddevSampleAggregates = {
  __typename?: 'PoolStddevSampleAggregates';
  /** Sample standard deviation of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolSumAggregates = {
  __typename?: 'PoolSumAggregates';
  /** Sum of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount: Scalars['BigFloat']['output'];
  /** Sum of buyPrice across the matching connection */
  buyPrice: Scalars['Float']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips: Scalars['BigInt']['output'];
  /** Sum of price across the matching connection */
  price: Scalars['Float']['output'];
  /** Sum of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount: Scalars['BigFloat']['output'];
  /** Sum of rangeOrderPrice across the matching connection */
  rangeOrderPrice: Scalars['Float']['output'];
  /** Sum of sellPrice across the matching connection */
  sellPrice: Scalars['Float']['output'];
};

export type PoolVariancePopulationAggregates = {
  __typename?: 'PoolVariancePopulationAggregates';
  /** Population variance of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population variance of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Population variance of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type PoolVarianceSampleAggregates = {
  __typename?: 'PoolVarianceSampleAggregates';
  /** Sample variance of baseLiquidityAmount across the matching connection */
  baseLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of buyPrice across the matching connection */
  buyPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of quoteLiquidityAmount across the matching connection */
  quoteLiquidityAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rangeOrderPrice across the matching connection */
  rangeOrderPrice?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of sellPrice across the matching connection */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of `Pool` values. */
export type PoolsConnection = {
  __typename?: 'PoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PoolAggregates>;
  /** A list of edges which contains the `Pool` and cursor to aid in pagination. */
  edges: Array<PoolsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PoolAggregates>>;
  /** A list of `Pool` objects. */
  nodes: Array<Pool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Pool` values. */
export type PoolsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PoolGroupBy>;
  having?: InputMaybe<PoolHavingInput>;
};

/** A `Pool` edge in the connection. */
export type PoolsEdge = {
  __typename?: 'PoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Pool` at the end of the edge. */
  node: Pool;
};

/** Methods to use when ordering `Pool`. */
export type PoolsOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'BASE_LIQUIDITY_AMOUNT_ASC'
  | 'BASE_LIQUIDITY_AMOUNT_DESC'
  | 'BUY_PRICE_ASC'
  | 'BUY_PRICE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS_ASC'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS_DESC'
  | 'NATURAL'
  | 'OPEN_ORDERS_ASC'
  | 'OPEN_ORDERS_DESC'
  | 'PRICE_ASC'
  | 'PRICE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC'
  | 'QUOTE_LIQUIDITY_AMOUNT_ASC'
  | 'QUOTE_LIQUIDITY_AMOUNT_DESC'
  | 'RANGE_ORDER_PRICE_ASC'
  | 'RANGE_ORDER_PRICE_DESC'
  | 'SELL_PRICE_ASC'
  | 'SELL_PRICE_DESC';

export type PriceQueryInput = {
  address: Scalars['String']['input'];
  chainId: Scalars['String']['input'];
  date?: InputMaybe<Scalars['Datetime']['input']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `_PrismaMigration` using its globally unique `ID`. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  _prismaMigrationById?: Maybe<_PrismaMigration>;
  /** Reads a single `AccountLink` using its globally unique `ID`. */
  accountLink?: Maybe<AccountLink>;
  accountLinkById?: Maybe<AccountLink>;
  /** Reads and enables pagination through a set of `AccountLink`. */
  allAccountLinks?: Maybe<AccountLinksConnection>;
  /** Reads and enables pagination through a set of `Auction`. */
  allAuctions?: Maybe<AuctionsConnection>;
  /** Reads and enables pagination through a set of `Banner`. */
  allBanners?: Maybe<BannersConnection>;
  /** Reads and enables pagination through a set of `BoostBalance`. */
  allBoostBalances?: Maybe<BoostBalancesConnection>;
  /** Reads and enables pagination through a set of `BoostPool`. */
  allBoostPools?: Maybe<BoostPoolsConnection>;
  /** Reads and enables pagination through a set of `BoostSafeMode`. */
  allBoostSafeModes?: Maybe<BoostSafeModesConnection>;
  /** Reads and enables pagination through a set of `BrokerAccountEarnedFee`. */
  allBrokerAccountEarnedFees?: Maybe<BrokerAccountEarnedFeesConnection>;
  /** Reads and enables pagination through a set of `BrokerAccount`. */
  allBrokerAccounts?: Maybe<BrokerAccountsConnection>;
  /** Reads and enables pagination through a set of `Circulation`. */
  allCirculations?: Maybe<CirculationsConnection>;
  /** Reads and enables pagination through a set of `DepositBalance`. */
  allDepositBalances?: Maybe<DepositBalancesConnection>;
  /** Reads and enables pagination through a set of `EnvironmentAddress`. */
  allEnvironmentAddresses?: Maybe<EnvironmentAddressesConnection>;
  /** Reads and enables pagination through a set of `FlipSupply`. */
  allFlipSupplies?: Maybe<FlipSuppliesConnection>;
  /** Reads and enables pagination through a set of `LpAccount`. */
  allLpAccounts?: Maybe<LpAccountsConnection>;
  /** Reads and enables pagination through a set of `LpTotalBalance`. */
  allLpTotalBalances?: Maybe<LpTotalBalancesConnection>;
  /** Reads and enables pagination through a set of `Pool`. */
  allPools?: Maybe<PoolsConnection>;
  /** Reads and enables pagination through a set of `_PrismaMigration`. */
  allPrismaMigrations?: Maybe<_PrismaMigrationsConnection>;
  /** Reads and enables pagination through a set of `SupportedAsset`. */
  allSupportedAssets?: Maybe<SupportedAssetsConnection>;
  /** Reads and enables pagination through a set of `TokenPrice`. */
  allTokenPrices?: Maybe<TokenPricesConnection>;
  /** Reads and enables pagination through a set of `TradingStrategy`. */
  allTradingStrategies?: Maybe<TradingStrategiesConnection>;
  /** Reads and enables pagination through a set of `TradingStrategyLimit`. */
  allTradingStrategyLimits?: Maybe<TradingStrategyLimitsConnection>;
  /** Reads and enables pagination through a set of `Unregistered`. */
  allUnregistereds?: Maybe<UnregisteredsConnection>;
  /** Reads and enables pagination through a set of `Validator`. */
  allValidators?: Maybe<ValidatorsConnection>;
  /** Reads a single `Auction` using its globally unique `ID`. */
  auction?: Maybe<Auction>;
  auctionById?: Maybe<Auction>;
  /** Reads a single `Banner` using its globally unique `ID`. */
  banner?: Maybe<Banner>;
  bannerByApp?: Maybe<Banner>;
  /** Reads a single `BoostPool` using its globally unique `ID`. */
  boostPool?: Maybe<BoostPool>;
  boostPoolById?: Maybe<BoostPool>;
  /** Reads a single `BoostSafeMode` using its globally unique `ID`. */
  boostSafeMode?: Maybe<BoostSafeMode>;
  boostSafeModeById?: Maybe<BoostSafeMode>;
  /** Reads a single `BrokerAccount` using its globally unique `ID`. */
  brokerAccount?: Maybe<BrokerAccount>;
  brokerAccountByIdSs58?: Maybe<BrokerAccount>;
  /** Reads a single `BrokerAccountEarnedFee` using its globally unique `ID`. */
  brokerAccountEarnedFee?: Maybe<BrokerAccountEarnedFee>;
  brokerAccountEarnedFeeById?: Maybe<BrokerAccountEarnedFee>;
  /** Reads a single `Circulation` using its globally unique `ID`. */
  circulation?: Maybe<Circulation>;
  circulationById?: Maybe<Circulation>;
  /** Reads a single `EnvironmentAddress` using its globally unique `ID`. */
  environmentAddress?: Maybe<EnvironmentAddress>;
  environmentAddressById?: Maybe<EnvironmentAddress>;
  /** Reads a single `FlipSupply` using its globally unique `ID`. */
  flipSupply?: Maybe<FlipSupply>;
  flipSupplyById?: Maybe<FlipSupply>;
  getTokenPrices: Array<TokenPrice>;
  /** Reads a single `LpAccount` using its globally unique `ID`. */
  lpAccount?: Maybe<LpAccount>;
  lpAccountByIdSs58?: Maybe<LpAccount>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  pendingDeposits: Array<Maybe<PendingDeposit>>;
  /** Reads a single `Pool` using its globally unique `ID`. */
  pool?: Maybe<Pool>;
  poolById?: Maybe<Pool>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `TokenPrice` using its globally unique `ID`. */
  tokenPrice?: Maybe<TokenPrice>;
  tokenPriceByChainIdAndAddress?: Maybe<TokenPrice>;
  /** Reads a single `TradingStrategyLimit` using its globally unique `ID`. */
  tradingStrategyLimit?: Maybe<TradingStrategyLimit>;
  tradingStrategyLimitById?: Maybe<TradingStrategyLimit>;
  /** Reads a single `Validator` using its globally unique `ID`. */
  validator?: Maybe<Validator>;
  validatorByIdHex?: Maybe<Validator>;
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountLinkArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountLinkByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountLinkCondition>;
  filter?: InputMaybe<AccountLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAuctionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuctionCondition>;
  filter?: InputMaybe<AuctionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuctionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBannersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BannerCondition>;
  filter?: InputMaybe<BannerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BannersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostBalanceCondition>;
  filter?: InputMaybe<BoostBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostPoolCondition>;
  filter?: InputMaybe<BoostPoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostPoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostSafeModesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostSafeModeCondition>;
  filter?: InputMaybe<BoostSafeModeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostSafeModesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerAccountEarnedFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAccountEarnedFeeCondition>;
  filter?: InputMaybe<BrokerAccountEarnedFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAccountEarnedFeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAccountCondition>;
  filter?: InputMaybe<BrokerAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCirculationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CirculationCondition>;
  filter?: InputMaybe<CirculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CirculationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDepositBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DepositBalanceCondition>;
  filter?: InputMaybe<DepositBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DepositBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEnvironmentAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentAddressCondition>;
  filter?: InputMaybe<EnvironmentAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFlipSuppliesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FlipSupplyCondition>;
  filter?: InputMaybe<FlipSupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FlipSuppliesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpAccountCondition>;
  filter?: InputMaybe<LpAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLpTotalBalancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LpTotalBalanceCondition>;
  filter?: InputMaybe<LpTotalBalanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LpTotalBalancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolCondition>;
  filter?: InputMaybe<PoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrismaMigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<_PrismaMigrationCondition>;
  filter?: InputMaybe<_PrismaMigrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSupportedAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupportedAssetCondition>;
  filter?: InputMaybe<SupportedAssetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupportedAssetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTokenPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TokenPriceCondition>;
  filter?: InputMaybe<TokenPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TokenPricesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTradingStrategiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyCondition>;
  filter?: InputMaybe<TradingStrategyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTradingStrategyLimitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TradingStrategyLimitCondition>;
  filter?: InputMaybe<TradingStrategyLimitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TradingStrategyLimitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUnregisteredsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UnregisteredCondition>;
  filter?: InputMaybe<UnregisteredFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnregisteredsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllValidatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBannerArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBannerByAppArgs = {
  app: App;
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostPoolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostSafeModeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostSafeModeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerAccountArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerAccountByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerAccountEarnedFeeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerAccountEarnedFeeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCirculationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCirculationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentAddressArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentAddressByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlipSupplyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFlipSupplyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetTokenPricesArgs = {
  input: Array<PriceQueryInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLpAccountArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLpAccountByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPendingDepositsArgs = {
  input: PendingDepositsInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenPriceArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenPriceByChainIdAndAddressArgs = {
  address: Scalars['String']['input'];
  chainId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyLimitArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTradingStrategyLimitByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatorByIdHexArgs = {
  idHex: Scalars['String']['input'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

export type SupportedAsset = {
  __typename?: 'SupportedAsset';
  id: ChainflipAsset;
};

export type SupportedAssetAggregates = {
  __typename?: 'SupportedAssetAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SupportedAssetDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A condition to be used against `SupportedAsset` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SupportedAssetCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<ChainflipAsset>;
};

export type SupportedAssetDistinctCountAggregates = {
  __typename?: 'SupportedAssetDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SupportedAsset` object types. All fields are combined with a logical ‘and.’ */
export type SupportedAssetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SupportedAssetFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<ChainflipAssetFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SupportedAssetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SupportedAssetFilter>>;
};

/** A connection to a list of `SupportedAsset` values. */
export type SupportedAssetsConnection = {
  __typename?: 'SupportedAssetsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SupportedAssetAggregates>;
  /** A list of edges which contains the `SupportedAsset` and cursor to aid in pagination. */
  edges: Array<SupportedAssetsEdge>;
  /** A list of `SupportedAsset` objects. */
  nodes: Array<SupportedAsset>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SupportedAsset` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SupportedAsset` edge in the connection. */
export type SupportedAssetsEdge = {
  __typename?: 'SupportedAssetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SupportedAsset` at the end of the edge. */
  node: SupportedAsset;
};

/** Methods to use when ordering `SupportedAsset`. */
export type SupportedAssetsOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL';

export type TokenPrice = Node & {
  __typename?: 'TokenPrice';
  address: Scalars['String']['output'];
  chainId: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  usdPrice: Scalars['Float']['output'];
};

export type TokenPriceAggregates = {
  __typename?: 'TokenPriceAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TokenPriceAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TokenPriceDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TokenPriceMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TokenPriceMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TokenPriceStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TokenPriceStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TokenPriceSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TokenPriceVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TokenPriceVarianceSampleAggregates>;
};

export type TokenPriceAverageAggregates = {
  __typename?: 'TokenPriceAverageAggregates';
  /** Mean average of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * A condition to be used against `TokenPrice` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TokenPriceCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `chainId` field. */
  chainId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `usdPrice` field. */
  usdPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type TokenPriceDistinctCountAggregates = {
  __typename?: 'TokenPriceDistinctCountAggregates';
  /** Distinct count of address across the matching connection */
  address?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chainId across the matching connection */
  chainId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TokenPrice` object types. All fields are combined with a logical ‘and.’ */
export type TokenPriceFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TokenPriceFilter>>;
  /** Filter by the object’s `chainId` field. */
  chainId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TokenPriceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TokenPriceFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usdPrice` field. */
  usdPrice?: InputMaybe<FloatFilter>;
};

/** Grouping methods for `TokenPrice` for usage during aggregation. */
export type TokenPriceGroupBy =
  | 'ADDRESS'
  | 'CHAIN_ID'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'USD_PRICE';

export type TokenPriceHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

/** Conditions for `TokenPrice` aggregates. */
export type TokenPriceHavingInput = {
  AND?: InputMaybe<Array<TokenPriceHavingInput>>;
  OR?: InputMaybe<Array<TokenPriceHavingInput>>;
  average?: InputMaybe<TokenPriceHavingAverageInput>;
  distinctCount?: InputMaybe<TokenPriceHavingDistinctCountInput>;
  max?: InputMaybe<TokenPriceHavingMaxInput>;
  min?: InputMaybe<TokenPriceHavingMinInput>;
  stddevPopulation?: InputMaybe<TokenPriceHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TokenPriceHavingStddevSampleInput>;
  sum?: InputMaybe<TokenPriceHavingSumInput>;
  variancePopulation?: InputMaybe<TokenPriceHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TokenPriceHavingVarianceSampleInput>;
};

export type TokenPriceHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  usdPrice?: InputMaybe<HavingFloatFilter>;
};

export type TokenPriceMaxAggregates = {
  __typename?: 'TokenPriceMaxAggregates';
  /** Maximum of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceMinAggregates = {
  __typename?: 'TokenPriceMinAggregates';
  /** Minimum of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceStddevPopulationAggregates = {
  __typename?: 'TokenPriceStddevPopulationAggregates';
  /** Population standard deviation of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceStddevSampleAggregates = {
  __typename?: 'TokenPriceStddevSampleAggregates';
  /** Sample standard deviation of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceSumAggregates = {
  __typename?: 'TokenPriceSumAggregates';
  /** Sum of usdPrice across the matching connection */
  usdPrice: Scalars['Float']['output'];
};

export type TokenPriceVariancePopulationAggregates = {
  __typename?: 'TokenPriceVariancePopulationAggregates';
  /** Population variance of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

export type TokenPriceVarianceSampleAggregates = {
  __typename?: 'TokenPriceVarianceSampleAggregates';
  /** Sample variance of usdPrice across the matching connection */
  usdPrice?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of `TokenPrice` values. */
export type TokenPricesConnection = {
  __typename?: 'TokenPricesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TokenPriceAggregates>;
  /** A list of edges which contains the `TokenPrice` and cursor to aid in pagination. */
  edges: Array<TokenPricesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TokenPriceAggregates>>;
  /** A list of `TokenPrice` objects. */
  nodes: Array<TokenPrice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TokenPrice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TokenPrice` values. */
export type TokenPricesConnectionGroupedAggregatesArgs = {
  groupBy: Array<TokenPriceGroupBy>;
  having?: InputMaybe<TokenPriceHavingInput>;
};

/** A `TokenPrice` edge in the connection. */
export type TokenPricesEdge = {
  __typename?: 'TokenPricesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TokenPrice` at the end of the edge. */
  node: TokenPrice;
};

/** Methods to use when ordering `TokenPrice`. */
export type TokenPricesOrderBy =
  | 'ADDRESS_ASC'
  | 'ADDRESS_DESC'
  | 'CHAIN_ID_ASC'
  | 'CHAIN_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USD_PRICE_ASC'
  | 'USD_PRICE_DESC';

/** A connection to a list of `TradingStrategy` values. */
export type TradingStrategiesConnection = {
  __typename?: 'TradingStrategiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TradingStrategyAggregates>;
  /** A list of edges which contains the `TradingStrategy` and cursor to aid in pagination. */
  edges: Array<TradingStrategiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TradingStrategyAggregates>>;
  /** A list of `TradingStrategy` objects. */
  nodes: Array<TradingStrategy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TradingStrategy` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TradingStrategy` values. */
export type TradingStrategiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<TradingStrategyGroupBy>;
  having?: InputMaybe<TradingStrategyHavingInput>;
};

/** A `TradingStrategy` edge in the connection. */
export type TradingStrategiesEdge = {
  __typename?: 'TradingStrategiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TradingStrategy` at the end of the edge. */
  node: TradingStrategy;
};

/** Methods to use when ordering `TradingStrategy`. */
export type TradingStrategiesOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_BALANCE_ASC'
  | 'BASE_ASSET_BALANCE_DESC'
  | 'BASE_ASSET_BALANCE_USD_ASC'
  | 'BASE_ASSET_BALANCE_USD_DESC'
  | 'BASE_ASSET_DESC'
  | 'BUY_TICK_ASC'
  | 'BUY_TICK_DESC'
  | 'NATURAL'
  | 'OWNER_ACCOUNT_ID_SS58_ASC'
  | 'OWNER_ACCOUNT_ID_SS58_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_BALANCE_ASC'
  | 'QUOTE_ASSET_BALANCE_DESC'
  | 'QUOTE_ASSET_BALANCE_USD_ASC'
  | 'QUOTE_ASSET_BALANCE_USD_DESC'
  | 'QUOTE_ASSET_DESC'
  | 'SELL_TICK_ASC'
  | 'SELL_TICK_DESC'
  | 'STRATEGY_ACCOUNT_ID_SS58_ASC'
  | 'STRATEGY_ACCOUNT_ID_SS58_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type TradingStrategy = {
  __typename?: 'TradingStrategy';
  baseAsset: ChainflipAsset;
  baseAssetBalance: Scalars['BigFloat']['output'];
  baseAssetBalanceUsd: Scalars['BigFloat']['output'];
  buyTick: Scalars['Int']['output'];
  ownerAccountIdSs58: Scalars['String']['output'];
  quoteAsset: ChainflipAsset;
  quoteAssetBalance: Scalars['BigFloat']['output'];
  quoteAssetBalanceUsd: Scalars['BigFloat']['output'];
  sellTick: Scalars['Int']['output'];
  strategyAccountIdSs58: Scalars['String']['output'];
  type: TradingStrategyType;
};

export type TradingStrategyAggregates = {
  __typename?: 'TradingStrategyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TradingStrategyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TradingStrategyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TradingStrategyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TradingStrategyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TradingStrategyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TradingStrategyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TradingStrategySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TradingStrategyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TradingStrategyVarianceSampleAggregates>;
};

export type TradingStrategyAverageAggregates = {
  __typename?: 'TradingStrategyAverageAggregates';
  /** Mean average of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TradingStrategy` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TradingStrategyCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseAssetBalance` field. */
  baseAssetBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseAssetBalanceUsd` field. */
  baseAssetBalanceUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `buyTick` field. */
  buyTick?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ownerAccountIdSs58` field. */
  ownerAccountIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `quoteAssetBalance` field. */
  quoteAssetBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteAssetBalanceUsd` field. */
  quoteAssetBalanceUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sellTick` field. */
  sellTick?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `strategyAccountIdSs58` field. */
  strategyAccountIdSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<TradingStrategyType>;
};

export type TradingStrategyDistinctCountAggregates = {
  __typename?: 'TradingStrategyDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ownerAccountIdSs58 across the matching connection */
  ownerAccountIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of strategyAccountIdSs58 across the matching connection */
  strategyAccountIdSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TradingStrategy` object types. All fields are combined with a logical ‘and.’ */
export type TradingStrategyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingStrategyFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseAssetBalance` field. */
  baseAssetBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseAssetBalanceUsd` field. */
  baseAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `buyTick` field. */
  buyTick?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TradingStrategyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingStrategyFilter>>;
  /** Filter by the object’s `ownerAccountIdSs58` field. */
  ownerAccountIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `quoteAssetBalance` field. */
  quoteAssetBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteAssetBalanceUsd` field. */
  quoteAssetBalanceUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `sellTick` field. */
  sellTick?: InputMaybe<IntFilter>;
  /** Filter by the object’s `strategyAccountIdSs58` field. */
  strategyAccountIdSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<TradingStrategyTypeFilter>;
};

/** Grouping methods for `TradingStrategy` for usage during aggregation. */
export type TradingStrategyGroupBy =
  | 'BASE_ASSET'
  | 'BASE_ASSET_BALANCE'
  | 'BASE_ASSET_BALANCE_USD'
  | 'BUY_TICK'
  | 'OWNER_ACCOUNT_ID_SS58'
  | 'QUOTE_ASSET'
  | 'QUOTE_ASSET_BALANCE'
  | 'QUOTE_ASSET_BALANCE_USD'
  | 'SELL_TICK'
  | 'TYPE';

export type TradingStrategyHavingAverageInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingDistinctCountInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `TradingStrategy` aggregates. */
export type TradingStrategyHavingInput = {
  AND?: InputMaybe<Array<TradingStrategyHavingInput>>;
  OR?: InputMaybe<Array<TradingStrategyHavingInput>>;
  average?: InputMaybe<TradingStrategyHavingAverageInput>;
  distinctCount?: InputMaybe<TradingStrategyHavingDistinctCountInput>;
  max?: InputMaybe<TradingStrategyHavingMaxInput>;
  min?: InputMaybe<TradingStrategyHavingMinInput>;
  stddevPopulation?: InputMaybe<TradingStrategyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TradingStrategyHavingStddevSampleInput>;
  sum?: InputMaybe<TradingStrategyHavingSumInput>;
  variancePopulation?: InputMaybe<TradingStrategyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TradingStrategyHavingVarianceSampleInput>;
};

export type TradingStrategyHavingMaxInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingMinInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingStddevPopulationInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingStddevSampleInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingSumInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingVariancePopulationInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyHavingVarianceSampleInput = {
  baseAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  baseAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  buyTick?: InputMaybe<HavingIntFilter>;
  quoteAssetBalance?: InputMaybe<HavingBigfloatFilter>;
  quoteAssetBalanceUsd?: InputMaybe<HavingBigfloatFilter>;
  sellTick?: InputMaybe<HavingIntFilter>;
};

export type TradingStrategyLimit = Node & {
  __typename?: 'TradingStrategyLimit';
  asset: ChainflipAsset;
  id: Scalars['Int']['output'];
  minimumAddedFundsAmount: Scalars['BigFloat']['output'];
  minimumDeploymentAmount: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type TradingStrategyLimitAggregates = {
  __typename?: 'TradingStrategyLimitAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TradingStrategyLimitAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TradingStrategyLimitDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TradingStrategyLimitMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TradingStrategyLimitMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TradingStrategyLimitStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TradingStrategyLimitStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TradingStrategyLimitSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TradingStrategyLimitVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TradingStrategyLimitVarianceSampleAggregates>;
};

export type TradingStrategyLimitAverageAggregates = {
  __typename?: 'TradingStrategyLimitAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TradingStrategyLimit` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TradingStrategyLimitCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minimumAddedFundsAmount` field. */
  minimumAddedFundsAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minimumDeploymentAmount` field. */
  minimumDeploymentAmount?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type TradingStrategyLimitDistinctCountAggregates = {
  __typename?: 'TradingStrategyLimitDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TradingStrategyLimit` object types. All fields are combined with a logical ‘and.’ */
export type TradingStrategyLimitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TradingStrategyLimitFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minimumAddedFundsAmount` field. */
  minimumAddedFundsAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minimumDeploymentAmount` field. */
  minimumDeploymentAmount?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TradingStrategyLimitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TradingStrategyLimitFilter>>;
};

/** Grouping methods for `TradingStrategyLimit` for usage during aggregation. */
export type TradingStrategyLimitGroupBy =
  | 'MINIMUM_ADDED_FUNDS_AMOUNT'
  | 'MINIMUM_DEPLOYMENT_AMOUNT';

export type TradingStrategyLimitHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `TradingStrategyLimit` aggregates. */
export type TradingStrategyLimitHavingInput = {
  AND?: InputMaybe<Array<TradingStrategyLimitHavingInput>>;
  OR?: InputMaybe<Array<TradingStrategyLimitHavingInput>>;
  average?: InputMaybe<TradingStrategyLimitHavingAverageInput>;
  distinctCount?: InputMaybe<TradingStrategyLimitHavingDistinctCountInput>;
  max?: InputMaybe<TradingStrategyLimitHavingMaxInput>;
  min?: InputMaybe<TradingStrategyLimitHavingMinInput>;
  stddevPopulation?: InputMaybe<TradingStrategyLimitHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TradingStrategyLimitHavingStddevSampleInput>;
  sum?: InputMaybe<TradingStrategyLimitHavingSumInput>;
  variancePopulation?: InputMaybe<TradingStrategyLimitHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TradingStrategyLimitHavingVarianceSampleInput>;
};

export type TradingStrategyLimitHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  minimumAddedFundsAmount?: InputMaybe<HavingBigfloatFilter>;
  minimumDeploymentAmount?: InputMaybe<HavingBigfloatFilter>;
};

export type TradingStrategyLimitMaxAggregates = {
  __typename?: 'TradingStrategyLimitMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitMinAggregates = {
  __typename?: 'TradingStrategyLimitMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitStddevPopulationAggregates = {
  __typename?: 'TradingStrategyLimitStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitStddevSampleAggregates = {
  __typename?: 'TradingStrategyLimitStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitSumAggregates = {
  __typename?: 'TradingStrategyLimitSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount: Scalars['BigFloat']['output'];
  /** Sum of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount: Scalars['BigFloat']['output'];
};

export type TradingStrategyLimitVariancePopulationAggregates = {
  __typename?: 'TradingStrategyLimitVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyLimitVarianceSampleAggregates = {
  __typename?: 'TradingStrategyLimitVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minimumAddedFundsAmount across the matching connection */
  minimumAddedFundsAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minimumDeploymentAmount across the matching connection */
  minimumDeploymentAmount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `TradingStrategyLimit` values. */
export type TradingStrategyLimitsConnection = {
  __typename?: 'TradingStrategyLimitsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TradingStrategyLimitAggregates>;
  /** A list of edges which contains the `TradingStrategyLimit` and cursor to aid in pagination. */
  edges: Array<TradingStrategyLimitsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TradingStrategyLimitAggregates>>;
  /** A list of `TradingStrategyLimit` objects. */
  nodes: Array<TradingStrategyLimit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TradingStrategyLimit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TradingStrategyLimit` values. */
export type TradingStrategyLimitsConnectionGroupedAggregatesArgs = {
  groupBy: Array<TradingStrategyLimitGroupBy>;
  having?: InputMaybe<TradingStrategyLimitHavingInput>;
};

/** A `TradingStrategyLimit` edge in the connection. */
export type TradingStrategyLimitsEdge = {
  __typename?: 'TradingStrategyLimitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TradingStrategyLimit` at the end of the edge. */
  node: TradingStrategyLimit;
};

/** Methods to use when ordering `TradingStrategyLimit`. */
export type TradingStrategyLimitsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MINIMUM_ADDED_FUNDS_AMOUNT_ASC'
  | 'MINIMUM_ADDED_FUNDS_AMOUNT_DESC'
  | 'MINIMUM_DEPLOYMENT_AMOUNT_ASC'
  | 'MINIMUM_DEPLOYMENT_AMOUNT_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type TradingStrategyMaxAggregates = {
  __typename?: 'TradingStrategyMaxAggregates';
  /** Maximum of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['Int']['output']>;
  /** Maximum of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['Int']['output']>;
};

export type TradingStrategyMinAggregates = {
  __typename?: 'TradingStrategyMinAggregates';
  /** Minimum of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['Int']['output']>;
  /** Minimum of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['Int']['output']>;
};

export type TradingStrategyStddevPopulationAggregates = {
  __typename?: 'TradingStrategyStddevPopulationAggregates';
  /** Population standard deviation of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyStddevSampleAggregates = {
  __typename?: 'TradingStrategyStddevSampleAggregates';
  /** Sample standard deviation of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategySumAggregates = {
  __typename?: 'TradingStrategySumAggregates';
  /** Sum of baseAssetBalance across the matching connection */
  baseAssetBalance: Scalars['BigFloat']['output'];
  /** Sum of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd: Scalars['BigFloat']['output'];
  /** Sum of buyTick across the matching connection */
  buyTick: Scalars['BigInt']['output'];
  /** Sum of quoteAssetBalance across the matching connection */
  quoteAssetBalance: Scalars['BigFloat']['output'];
  /** Sum of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd: Scalars['BigFloat']['output'];
  /** Sum of sellTick across the matching connection */
  sellTick: Scalars['BigInt']['output'];
};

export type TradingStrategyType =
  | 'TickZeroCentered';

/** A filter to be used against TradingStrategyType fields. All fields are combined with a logical ‘and.’ */
export type TradingStrategyTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TradingStrategyType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TradingStrategyType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TradingStrategyType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TradingStrategyType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TradingStrategyType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TradingStrategyType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TradingStrategyType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TradingStrategyType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TradingStrategyType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TradingStrategyType>>;
};

export type TradingStrategyVariancePopulationAggregates = {
  __typename?: 'TradingStrategyVariancePopulationAggregates';
  /** Population variance of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type TradingStrategyVarianceSampleAggregates = {
  __typename?: 'TradingStrategyVarianceSampleAggregates';
  /** Sample variance of baseAssetBalance across the matching connection */
  baseAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseAssetBalanceUsd across the matching connection */
  baseAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of buyTick across the matching connection */
  buyTick?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteAssetBalance across the matching connection */
  quoteAssetBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteAssetBalanceUsd across the matching connection */
  quoteAssetBalanceUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sellTick across the matching connection */
  sellTick?: Maybe<Scalars['BigFloat']['output']>;
};

export type Unregistered = {
  __typename?: 'Unregistered';
  idSs58: Scalars['String']['output'];
};

export type UnregisteredAggregates = {
  __typename?: 'UnregisteredAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UnregisteredDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A condition to be used against `Unregistered` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UnregisteredCondition = {
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
};

export type UnregisteredDistinctCountAggregates = {
  __typename?: 'UnregisteredDistinctCountAggregates';
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Unregistered` object types. All fields are combined with a logical ‘and.’ */
export type UnregisteredFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnregisteredFilter>>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UnregisteredFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnregisteredFilter>>;
};

/** A connection to a list of `Unregistered` values. */
export type UnregisteredsConnection = {
  __typename?: 'UnregisteredsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UnregisteredAggregates>;
  /** A list of edges which contains the `Unregistered` and cursor to aid in pagination. */
  edges: Array<UnregisteredsEdge>;
  /** A list of `Unregistered` objects. */
  nodes: Array<Unregistered>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Unregistered` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Unregistered` edge in the connection. */
export type UnregisteredsEdge = {
  __typename?: 'UnregisteredsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Unregistered` at the end of the edge. */
  node: Unregistered;
};

/** Methods to use when ordering `Unregistered`. */
export type UnregisteredsOrderBy =
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'NATURAL';

export type Validator = Node & {
  __typename?: 'Validator';
  alias?: Maybe<Scalars['String']['output']>;
  apyBp?: Maybe<Scalars['Int']['output']>;
  boundRedeemAddress?: Maybe<Scalars['String']['output']>;
  idHex: Scalars['String']['output'];
  idSs58: Scalars['String']['output'];
  isBidding: Scalars['Boolean']['output'];
  isCurrentAuthority: Scalars['Boolean']['output'];
  isCurrentBackup: Scalars['Boolean']['output'];
  isKeyholder: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isQualified: Scalars['Boolean']['output'];
  lockedBalance: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  reputationPoints: Scalars['Int']['output'];
  role: AccountRole;
  unlockedBalance: Scalars['BigFloat']['output'];
};

export type ValidatorAggregates = {
  __typename?: 'ValidatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ValidatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ValidatorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ValidatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ValidatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ValidatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ValidatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ValidatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ValidatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ValidatorVarianceSampleAggregates>;
};

export type ValidatorAverageAggregates = {
  __typename?: 'ValidatorAverageAggregates';
  /** Mean average of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Validator` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ValidatorCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `apyBp` field. */
  apyBp?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `boundRedeemAddress` field. */
  boundRedeemAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idHex` field. */
  idHex?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isBidding` field. */
  isBidding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isCurrentAuthority` field. */
  isCurrentAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isCurrentBackup` field. */
  isCurrentBackup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isKeyholder` field. */
  isKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isOnline` field. */
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isQualified` field. */
  isQualified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lockedBalance` field. */
  lockedBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `reputationPoints` field. */
  reputationPoints?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<AccountRole>;
  /** Checks for equality with the object’s `unlockedBalance` field. */
  unlockedBalance?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type ValidatorDistinctCountAggregates = {
  __typename?: 'ValidatorDistinctCountAggregates';
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boundRedeemAddress across the matching connection */
  boundRedeemAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idHex across the matching connection */
  idHex?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isBidding across the matching connection */
  isBidding?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isCurrentAuthority across the matching connection */
  isCurrentAuthority?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isCurrentBackup across the matching connection */
  isCurrentBackup?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isKeyholder across the matching connection */
  isKeyholder?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isOnline across the matching connection */
  isOnline?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isQualified across the matching connection */
  isQualified?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of role across the matching connection */
  role?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Validator` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ValidatorFilter>>;
  /** Filter by the object’s `apyBp` field. */
  apyBp?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boundRedeemAddress` field. */
  boundRedeemAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idHex` field. */
  idHex?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isBidding` field. */
  isBidding?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isCurrentAuthority` field. */
  isCurrentAuthority?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isCurrentBackup` field. */
  isCurrentBackup?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isKeyholder` field. */
  isKeyholder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isOnline` field. */
  isOnline?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isQualified` field. */
  isQualified?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lockedBalance` field. */
  lockedBalance?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ValidatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ValidatorFilter>>;
  /** Filter by the object’s `reputationPoints` field. */
  reputationPoints?: InputMaybe<IntFilter>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<AccountRoleFilter>;
  /** Filter by the object’s `unlockedBalance` field. */
  unlockedBalance?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `Validator` for usage during aggregation. */
export type ValidatorGroupBy =
  | 'ALIAS'
  | 'APY_BP'
  | 'BOUND_REDEEM_ADDRESS'
  | 'IS_BIDDING'
  | 'IS_CURRENT_AUTHORITY'
  | 'IS_CURRENT_BACKUP'
  | 'IS_KEYHOLDER'
  | 'IS_ONLINE'
  | 'IS_QUALIFIED'
  | 'LOCKED_BALANCE'
  | 'REPUTATION_POINTS'
  | 'ROLE'
  | 'UNLOCKED_BALANCE';

export type ValidatorHavingAverageInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorHavingDistinctCountInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Validator` aggregates. */
export type ValidatorHavingInput = {
  AND?: InputMaybe<Array<ValidatorHavingInput>>;
  OR?: InputMaybe<Array<ValidatorHavingInput>>;
  average?: InputMaybe<ValidatorHavingAverageInput>;
  distinctCount?: InputMaybe<ValidatorHavingDistinctCountInput>;
  max?: InputMaybe<ValidatorHavingMaxInput>;
  min?: InputMaybe<ValidatorHavingMinInput>;
  stddevPopulation?: InputMaybe<ValidatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ValidatorHavingStddevSampleInput>;
  sum?: InputMaybe<ValidatorHavingSumInput>;
  variancePopulation?: InputMaybe<ValidatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ValidatorHavingVarianceSampleInput>;
};

export type ValidatorHavingMaxInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorHavingMinInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorHavingStddevPopulationInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorHavingStddevSampleInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorHavingSumInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorHavingVariancePopulationInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorHavingVarianceSampleInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  lockedBalance?: InputMaybe<HavingBigfloatFilter>;
  reputationPoints?: InputMaybe<HavingIntFilter>;
  unlockedBalance?: InputMaybe<HavingBigfloatFilter>;
};

export type ValidatorMaxAggregates = {
  __typename?: 'ValidatorMaxAggregates';
  /** Maximum of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['Int']['output']>;
  /** Maximum of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorMinAggregates = {
  __typename?: 'ValidatorMinAggregates';
  /** Minimum of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['Int']['output']>;
  /** Minimum of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorStddevPopulationAggregates = {
  __typename?: 'ValidatorStddevPopulationAggregates';
  /** Population standard deviation of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorStddevSampleAggregates = {
  __typename?: 'ValidatorStddevSampleAggregates';
  /** Sample standard deviation of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorSumAggregates = {
  __typename?: 'ValidatorSumAggregates';
  /** Sum of apyBp across the matching connection */
  apyBp: Scalars['BigInt']['output'];
  /** Sum of lockedBalance across the matching connection */
  lockedBalance: Scalars['BigFloat']['output'];
  /** Sum of reputationPoints across the matching connection */
  reputationPoints: Scalars['BigInt']['output'];
  /** Sum of unlockedBalance across the matching connection */
  unlockedBalance: Scalars['BigFloat']['output'];
};

export type ValidatorVariancePopulationAggregates = {
  __typename?: 'ValidatorVariancePopulationAggregates';
  /** Population variance of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorVarianceSampleAggregates = {
  __typename?: 'ValidatorVarianceSampleAggregates';
  /** Sample variance of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lockedBalance across the matching connection */
  lockedBalance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reputationPoints across the matching connection */
  reputationPoints?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of unlockedBalance across the matching connection */
  unlockedBalance?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Validator` values. */
export type ValidatorsConnection = {
  __typename?: 'ValidatorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ValidatorAggregates>;
  /** A list of edges which contains the `Validator` and cursor to aid in pagination. */
  edges: Array<ValidatorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ValidatorAggregates>>;
  /** A list of `Validator` objects. */
  nodes: Array<Validator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Validator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Validator` values. */
export type ValidatorsConnectionGroupedAggregatesArgs = {
  groupBy: Array<ValidatorGroupBy>;
  having?: InputMaybe<ValidatorHavingInput>;
};

/** A `Validator` edge in the connection. */
export type ValidatorsEdge = {
  __typename?: 'ValidatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Validator` at the end of the edge. */
  node: Validator;
};

/** Methods to use when ordering `Validator`. */
export type ValidatorsOrderBy =
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'APY_BP_ASC'
  | 'APY_BP_DESC'
  | 'BOUND_REDEEM_ADDRESS_ASC'
  | 'BOUND_REDEEM_ADDRESS_DESC'
  | 'ID_HEX_ASC'
  | 'ID_HEX_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'IS_BIDDING_ASC'
  | 'IS_BIDDING_DESC'
  | 'IS_CURRENT_AUTHORITY_ASC'
  | 'IS_CURRENT_AUTHORITY_DESC'
  | 'IS_CURRENT_BACKUP_ASC'
  | 'IS_CURRENT_BACKUP_DESC'
  | 'IS_KEYHOLDER_ASC'
  | 'IS_KEYHOLDER_DESC'
  | 'IS_ONLINE_ASC'
  | 'IS_ONLINE_DESC'
  | 'IS_QUALIFIED_ASC'
  | 'IS_QUALIFIED_DESC'
  | 'LOCKED_BALANCE_ASC'
  | 'LOCKED_BALANCE_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REPUTATION_POINTS_ASC'
  | 'REPUTATION_POINTS_DESC'
  | 'ROLE_ASC'
  | 'ROLE_DESC'
  | 'UNLOCKED_BALANCE_ASC'
  | 'UNLOCKED_BALANCE_DESC';

export type _PrismaMigration = Node & {
  __typename?: '_PrismaMigration';
  appliedStepsCount: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  logs?: Maybe<Scalars['String']['output']>;
  migrationName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  startedAt: Scalars['Datetime']['output'];
};

export type _PrismaMigrationAggregates = {
  __typename?: '_PrismaMigrationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<_PrismaMigrationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<_PrismaMigrationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<_PrismaMigrationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<_PrismaMigrationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<_PrismaMigrationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<_PrismaMigrationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<_PrismaMigrationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<_PrismaMigrationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<_PrismaMigrationVarianceSampleAggregates>;
};

export type _PrismaMigrationAverageAggregates = {
  __typename?: '_PrismaMigrationAverageAggregates';
  /** Mean average of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `_PrismaMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type _PrismaMigrationCondition = {
  /** Checks for equality with the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `logs` field. */
  logs?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `migrationName` field. */
  migrationName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type _PrismaMigrationDistinctCountAggregates = {
  __typename?: '_PrismaMigrationDistinctCountAggregates';
  /** Distinct count of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of checksum across the matching connection */
  checksum?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of logs across the matching connection */
  logs?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of migrationName across the matching connection */
  migrationName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `_PrismaMigration` object types. All fields are combined with a logical ‘and.’ */
export type _PrismaMigrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checksum` field. */
  checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logs` field. */
  logs?: InputMaybe<StringFilter>;
  /** Filter by the object’s `migrationName` field. */
  migrationName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<_PrismaMigrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
};

export type _PrismaMigrationMaxAggregates = {
  __typename?: '_PrismaMigrationMaxAggregates';
  /** Maximum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
};

export type _PrismaMigrationMinAggregates = {
  __typename?: '_PrismaMigrationMinAggregates';
  /** Minimum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
};

export type _PrismaMigrationStddevPopulationAggregates = {
  __typename?: '_PrismaMigrationStddevPopulationAggregates';
  /** Population standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationStddevSampleAggregates = {
  __typename?: '_PrismaMigrationStddevSampleAggregates';
  /** Sample standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationSumAggregates = {
  __typename?: '_PrismaMigrationSumAggregates';
  /** Sum of appliedStepsCount across the matching connection */
  appliedStepsCount: Scalars['BigInt']['output'];
};

export type _PrismaMigrationVariancePopulationAggregates = {
  __typename?: '_PrismaMigrationVariancePopulationAggregates';
  /** Population variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationVarianceSampleAggregates = {
  __typename?: '_PrismaMigrationVarianceSampleAggregates';
  /** Sample variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnection = {
  __typename?: '_PrismaMigrationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<_PrismaMigrationAggregates>;
  /** A list of edges which contains the `_PrismaMigration` and cursor to aid in pagination. */
  edges: Array<_PrismaMigrationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<_PrismaMigrationAggregates>>;
  /** A list of `_PrismaMigration` objects. */
  nodes: Array<_PrismaMigration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `_PrismaMigration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<_PrismaMigrationsGroupBy>;
  having?: InputMaybe<_PrismaMigrationsHavingInput>;
};

/** A `_PrismaMigration` edge in the connection. */
export type _PrismaMigrationsEdge = {
  __typename?: '_PrismaMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `_PrismaMigration` at the end of the edge. */
  node: _PrismaMigration;
};

/** Grouping methods for `_PrismaMigration` for usage during aggregation. */
export type _PrismaMigrationsGroupBy =
  | 'APPLIED_STEPS_COUNT'
  | 'CHECKSUM'
  | 'FINISHED_AT'
  | 'FINISHED_AT_TRUNCATED_TO_DAY'
  | 'FINISHED_AT_TRUNCATED_TO_HOUR'
  | 'LOGS'
  | 'MIGRATION_NAME'
  | 'ROLLED_BACK_AT'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_DAY'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_HOUR'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR';

export type _PrismaMigrationsHavingAverageInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationsHavingDistinctCountInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `_PrismaMigration` aggregates. */
export type _PrismaMigrationsHavingInput = {
  AND?: InputMaybe<Array<_PrismaMigrationsHavingInput>>;
  OR?: InputMaybe<Array<_PrismaMigrationsHavingInput>>;
  average?: InputMaybe<_PrismaMigrationsHavingAverageInput>;
  distinctCount?: InputMaybe<_PrismaMigrationsHavingDistinctCountInput>;
  max?: InputMaybe<_PrismaMigrationsHavingMaxInput>;
  min?: InputMaybe<_PrismaMigrationsHavingMinInput>;
  stddevPopulation?: InputMaybe<_PrismaMigrationsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<_PrismaMigrationsHavingStddevSampleInput>;
  sum?: InputMaybe<_PrismaMigrationsHavingSumInput>;
  variancePopulation?: InputMaybe<_PrismaMigrationsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<_PrismaMigrationsHavingVarianceSampleInput>;
};

export type _PrismaMigrationsHavingMaxInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationsHavingMinInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationsHavingStddevPopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationsHavingStddevSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationsHavingSumInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationsHavingVariancePopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationsHavingVarianceSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `_PrismaMigration`. */
export type _PrismaMigrationsOrderBy =
  | 'APPLIED_STEPS_COUNT_ASC'
  | 'APPLIED_STEPS_COUNT_DESC'
  | 'CHECKSUM_ASC'
  | 'CHECKSUM_DESC'
  | 'FINISHED_AT_ASC'
  | 'FINISHED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOGS_ASC'
  | 'LOGS_DESC'
  | 'MIGRATION_NAME_ASC'
  | 'MIGRATION_NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLLED_BACK_AT_ASC'
  | 'ROLLED_BACK_AT_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC';

export type GetTotalDeployedBoostLiquidityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalDeployedBoostLiquidityQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', aggregates?: { __typename?: 'BoostPoolAggregates', sum?: { __typename?: 'BoostPoolSumAggregates', availableAmountValueUsd: string, unavailableAmountValueUsd: string } | null } | null } | null };

export type GetBrokerAccountCacheDataQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetBrokerAccountCacheDataQuery = { __typename?: 'Query', broker?: { __typename?: 'BrokerAccount', flipBalance: string, idSs58: string, bondedFlipBalance?: string | null, brokerVaultDepositAddress?: string | null, registrationId?: number | null, withdrawalAddress?: string | null, delegateBrokerId?: string | null, affiliates: { __typename?: 'BrokerAccountsConnection', nodes: Array<{ __typename?: 'BrokerAccount', registrationId?: number | null, idSs58: string, withdrawalAddress?: string | null }> }, feesEarned: { __typename?: 'BrokerAccountEarnedFeesConnection', groupedAggregates?: Array<{ __typename?: 'BrokerAccountEarnedFeeAggregates', keys?: Array<string> | null, sum?: { __typename?: 'BrokerAccountEarnedFeeSumAggregates', amount: string } | null }> | null } } | null };

export type GetBrokersBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokersBalancesQuery = { __typename?: 'Query', brokers?: { __typename?: 'BrokerAccountsConnection', nodes: Array<{ __typename?: 'BrokerAccount', flipBalance: string, idSs58: string, alias?: string | null }> } | null };

export type LpAccountWithBalancesFragment = { __typename?: 'LpAccount', idSs58: string, flipBalance: string, alias?: string | null, openOrders: any, earnedFeesValueUsd: string, balances: { __typename?: 'DepositBalancesConnection', nodes: Array<{ __typename?: 'DepositBalance', chain: ChainflipChain, asset: ChainflipAsset, amount: string }> }, boostBalances: { __typename?: 'BoostBalancesConnection', nodes: Array<{ __typename?: 'BoostBalance', availableAmount: string, availableAmountValueUsd: string, unavailableAmount: string, unavailableAmountValueUsd: string, pool: { __typename?: 'BoostPool', asset: ChainflipAsset } }> } };

export type GetCacheUndeployedLiquidityQueryVariables = Exact<{
  lpIdSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCacheUndeployedLiquidityQuery = { __typename?: 'Query', depositBalances?: { __typename?: 'DepositBalancesConnection', groupedAggregates?: Array<{ __typename?: 'DepositBalanceAggregates', keys?: Array<string> | null, sum?: { __typename?: 'DepositBalanceSumAggregates', amount: string } | null }> | null } | null };

export type GetCirculatingSupplyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCirculatingSupplyQuery = { __typename?: 'Query', circulation?: { __typename?: 'Circulation', circulatingSupply: string, totalSupply: string } | null };

export type GetEnvironmentAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnvironmentAddressQuery = { __typename?: 'Query', environmentAddress?: { __typename?: 'EnvironmentAddress', keyManagerAddress: string, stateChainGatewayAddress: string } | null };

export type GetValidatorByIdSs58QueryVariables = Exact<{
  validatorId: Scalars['String']['input'];
}>;


export type GetValidatorByIdSs58Query = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string }> } | null };

export type GetActiveCacheValidatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCacheValidatorsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string }> } | null };

export type GetTradingStrategyLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTradingStrategyLimitsQuery = { __typename?: 'Query', limits?: { __typename?: 'TradingStrategyLimitsConnection', nodes: Array<{ __typename?: 'TradingStrategyLimit', minimumDeploymentAmount: string, minimumAddedFundsAmount: string, asset: ChainflipAsset }> } | null };

export type GetAllSupportedAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSupportedAssetsQuery = { __typename?: 'Query', assets?: { __typename?: 'SupportedAssetsConnection', nodes: Array<{ __typename?: 'SupportedAsset', id: ChainflipAsset }> } | null };

export type GetAllBoostPoolsCacheQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBoostPoolsCacheQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, feeTierPips: number, asset: ChainflipAsset, availableAmount: string, availableAmountValueUsd: string, unavailableAmount: string, unavailableAmountValueUsd: string, boosters: { __typename?: 'BoostBalancesConnection', totalCount: number } }> } | null };

export type GetBoostPoolCacheQueryVariables = Exact<{
  chainflipAsset: ChainflipAsset;
  feeTierPips: Scalars['Int']['input'];
}>;


export type GetBoostPoolCacheQuery = { __typename?: 'Query', pools?: { __typename?: 'BoostPoolsConnection', nodes: Array<{ __typename?: 'BoostPool', id: number, availableAmount: string, unavailableAmount: string, availableAmountValueUsd: string, unavailableAmountValueUsd: string, balances: { __typename?: 'BoostBalancesConnection', nodes: Array<{ __typename?: 'BoostBalance', lpIdSs58: string, poolShare: number, availableAmount: string, unavailableAmount: string, availableAmountValueUsd: string, unavailableAmountValueUsd: string }> } }> } | null };

export type AllBoostBalancesForAccountQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type AllBoostBalancesForAccountQuery = { __typename?: 'Query', balances?: { __typename?: 'BoostBalancesConnection', nodes: Array<{ __typename?: 'BoostBalance', availableAmountValueUsd: string, unavailableAmountValueUsd: string, unavailableAmount: string, availableAmount: string, poolShare: number, pool: { __typename?: 'BoostPool', id: number, asset: ChainflipAsset, feeTierPips: number, availableAmount: string, unavailableAmount: string } }> } | null };

export type GetPendingDepositsQueryVariables = Exact<{
  address: Scalars['String']['input'];
  chain: Scalars['String']['input'];
  asset: Scalars['String']['input'];
}>;


export type GetPendingDepositsQuery = { __typename?: 'Query', pendingDeposits: Array<{ __typename?: 'PendingDeposit', amount: string, txRef?: string | null } | null> };

export type GetRuntimeVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRuntimeVersionQuery = { __typename?: 'Query', allEnvironmentAddresses?: { __typename?: 'EnvironmentAddressesConnection', nodes: Array<{ __typename?: 'EnvironmentAddress', runtimeVersion: number }> } | null };

export type CacheValidatorFragment = { __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string };

export type PoolFragment = { __typename?: 'Pool', id: number, baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, rangeOrderPrice: number };

export type GetFilteredLpAccountsWithBalancesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFilteredLpAccountsWithBalancesQuery = { __typename?: 'Query', lps?: { __typename?: 'LpAccountsConnection', totalCount: number, nodes: Array<{ __typename?: 'LpAccount', idSs58: string, flipBalance: string, alias?: string | null, openOrders: any, earnedFeesValueUsd: string, balances: { __typename?: 'DepositBalancesConnection', nodes: Array<{ __typename?: 'DepositBalance', chain: ChainflipChain, asset: ChainflipAsset, amount: string }> }, boostBalances: { __typename?: 'BoostBalancesConnection', nodes: Array<{ __typename?: 'BoostBalance', availableAmount: string, availableAmountValueUsd: string, unavailableAmount: string, unavailableAmountValueUsd: string, pool: { __typename?: 'BoostPool', asset: ChainflipAsset } }> } }> } | null, pools?: { __typename?: 'PoolsConnection', nodes: Array<{ __typename?: 'Pool', id: number, baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, rangeOrderPrice: number }> } | null };

export type GetCachePoolsQueryVariables = Exact<{
  baseAsset?: InputMaybe<ChainflipAsset>;
}>;


export type GetCachePoolsQuery = { __typename?: 'Query', pools?: { __typename?: 'PoolsConnection', nodes: Array<{ __typename?: 'Pool', baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, buyPrice: number, rangeOrderPrice: number, baseLiquidityAmount: string, quoteLiquidityAmount: string, liquidityFeeHundredthPips: number }> } | null };

export type GetCachePoolsWithOrderQueryVariables = Exact<{
  baseAsset?: InputMaybe<ChainflipAsset>;
}>;


export type GetCachePoolsWithOrderQuery = { __typename?: 'Query', pools?: { __typename?: 'PoolsConnection', nodes: Array<{ __typename?: 'Pool', baseAsset: ChainflipAsset, quoteAsset: ChainflipAsset, buyPrice: number, rangeOrderPrice: number, baseLiquidityAmount: string, quoteLiquidityAmount: string, liquidityFeeHundredthPips: number, openOrders?: any | null }> } | null };

export type BannerStatusQueryVariables = Exact<{
  app: App;
}>;


export type BannerStatusQuery = { __typename?: 'Query', banner?: { __typename?: 'BannersConnection', nodes: Array<{ __typename?: 'Banner', message: string, type: BannerType }> } | null };

export type GetLatestAuctionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestAuctionQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', minActiveBid?: string | null, startBlockNumber: number, endBlockNumber: number, currentHeight: number, projectedLockup?: string | null, redemptionPeriodAsPercentage: number, targetSetSize: number, authorityRotationEnabled: boolean } | null };

export type GetBitcoinBoostSafeModeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBitcoinBoostSafeModeQuery = { __typename?: 'Query', allBoostSafeModes?: { __typename?: 'BoostSafeModesConnection', nodes: Array<{ __typename?: 'BoostSafeMode', boostDepositsEnabled: boolean }> } | null };

export type GetAllEnvironmentAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEnvironmentAddressesQuery = { __typename?: 'Query', allEnvironmentAddresses?: { __typename?: 'EnvironmentAddressesConnection', nodes: Array<{ __typename?: 'EnvironmentAddress', redemptionTax: string }> } | null };

export type GetLatestFlipSupplyQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestFlipSupplyQueryQuery = { __typename?: 'Query', flipSupply?: { __typename?: 'FlipSupply', totalIssuance: string, offchainFunds: string, annualSystemCompoundedRewards: string } | null };

export type ValidatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidatorsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string }> } | null };

export type GetValidatorsByAccountIdsQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetValidatorsByAccountIdsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', idHex: string, idSs58: string, alias?: string | null, apyBp?: number | null, boundRedeemAddress?: string | null, isCurrentAuthority: boolean, isCurrentBackup: boolean, isQualified: boolean, isOnline: boolean, isBidding: boolean, isKeyholder: boolean, reputationPoints: number, lockedBalance: string, unlockedBalance: string }> } | null };

export type GetLinkedAccountsQueryVariables = Exact<{
  ethAddress: Scalars['String']['input'];
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetLinkedAccountsQuery = { __typename?: 'Query', links?: { __typename?: 'AccountLinksConnection', nodes: Array<{ __typename?: 'AccountLink', accountIdSs58: string }> } | null, unregistered?: { __typename?: 'UnregisteredsConnection', nodes: Array<{ __typename?: 'Unregistered', idSs58: string }> } | null };

export const LpAccountWithBalancesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LpAccountWithBalances"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LpAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","name":{"kind":"Name","value":"earnedFeesValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"depositBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boostBalances"},"name":{"kind":"Name","value":"boostBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"pool"},"name":{"kind":"Name","value":"boostPoolByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}}]}}]}}]}}]} as unknown as DocumentNode<LpAccountWithBalancesFragment, unknown>;
export const CacheValidatorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}}]}}]} as unknown as DocumentNode<CacheValidatorFragment, unknown>;
export const PoolFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pool"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pool"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}}]}}]} as unknown as DocumentNode<PoolFragment, unknown>;
export const GetTotalDeployedBoostLiquidityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTotalDeployedBoostLiquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTotalDeployedBoostLiquidityQuery, GetTotalDeployedBoostLiquidityQueryVariables>;
export const GetBrokerAccountCacheDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokerAccountCacheData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerAccountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"bondedFlipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"brokerVaultDepositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"delegateBrokerId"}},{"kind":"Field","alias":{"kind":"Name","value":"affiliates"},"name":{"kind":"Name","value":"brokerAccountsByDelegateBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAddress"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"feesEarned"},"name":{"kind":"Name","value":"brokerAccountEarnedFeesByBrokerAccountIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBrokerAccountCacheDataQuery, GetBrokerAccountCacheDataQueryVariables>;
export const GetBrokersBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokersBalances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"brokers"},"name":{"kind":"Name","value":"allBrokerAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]} as unknown as DocumentNode<GetBrokersBalancesQuery, GetBrokersBalancesQueryVariables>;
export const GetCacheUndeployedLiquidityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCacheUndeployedLiquidity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"depositBalances"},"name":{"kind":"Name","value":"allDepositBalances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lpIdSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lpIdSs58"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}}]}}]} as unknown as DocumentNode<GetCacheUndeployedLiquidityQuery, GetCacheUndeployedLiquidityQueryVariables>;
export const GetCirculatingSupplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCirculatingSupply"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"circulation"},"name":{"kind":"Name","value":"circulationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circulatingSupply"}},{"kind":"Field","name":{"kind":"Name","value":"totalSupply"}}]}}]}}]} as unknown as DocumentNode<GetCirculatingSupplyQuery, GetCirculatingSupplyQueryVariables>;
export const GetEnvironmentAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnvironmentAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"environmentAddress"},"name":{"kind":"Name","value":"environmentAddressById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyManagerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"stateChainGatewayAddress"}}]}}]}}]} as unknown as DocumentNode<GetEnvironmentAddressQuery, GetEnvironmentAddressQueryVariables>;
export const GetValidatorByIdSs58Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorByIdSs58"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}}]}}]} as unknown as DocumentNode<GetValidatorByIdSs58Query, GetValidatorByIdSs58QueryVariables>;
export const GetActiveCacheValidatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveCacheValidators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrentAuthority"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isCurrentBackup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}}]}}]} as unknown as DocumentNode<GetActiveCacheValidatorsQuery, GetActiveCacheValidatorsQueryVariables>;
export const GetTradingStrategyLimitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTradingStrategyLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"limits"},"name":{"kind":"Name","value":"allTradingStrategyLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minimumDeploymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAddedFundsAmount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}}]}}]}}]} as unknown as DocumentNode<GetTradingStrategyLimitsQuery, GetTradingStrategyLimitsQueryVariables>;
export const GetAllSupportedAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllSupportedAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assets"},"name":{"kind":"Name","value":"allSupportedAssets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllSupportedAssetsQuery, GetAllSupportedAssetsQueryVariables>;
export const GetAllBoostPoolsCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllBoostPoolsCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"boosters"},"name":{"kind":"Name","value":"boostBalancesByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllBoostPoolsCacheQuery, GetAllBoostPoolsCacheQueryVariables>;
export const GetBoostPoolCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBoostPoolCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chainflipAsset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allBoostPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierPips"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierPips"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chainflipAsset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"boostBalancesByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lpIdSs58"}},{"kind":"Field","name":{"kind":"Name","value":"poolShare"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBoostPoolCacheQuery, GetBoostPoolCacheQueryVariables>;
export const AllBoostBalancesForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllBoostBalancesForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"allBoostBalances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lpIdSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pool"},"name":{"kind":"Name","value":"boostPoolByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"feeTierPips"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"poolShare"}}]}}]}}]}}]} as unknown as DocumentNode<AllBoostBalancesForAccountQuery, AllBoostBalancesForAccountQueryVariables>;
export const GetPendingDepositsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPendingDeposits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingDeposits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"txRef"}}]}}]}}]} as unknown as DocumentNode<GetPendingDepositsQuery, GetPendingDepositsQueryVariables>;
export const GetRuntimeVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRuntimeVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allEnvironmentAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runtimeVersion"}}]}}]}}]}}]} as unknown as DocumentNode<GetRuntimeVersionQuery, GetRuntimeVersionQueryVariables>;
export const GetFilteredLpAccountsWithBalancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilteredLpAccountsWithBalances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lps"},"name":{"kind":"Name","value":"allLpAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LpAccountWithBalances"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allPools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pool"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LpAccountWithBalances"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LpAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"flipBalance"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}},{"kind":"Field","name":{"kind":"Name","value":"earnedFeesValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"balances"},"name":{"kind":"Name","value":"depositBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boostBalances"},"name":{"kind":"Name","value":"boostBalancesByLpIdSs58"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"availableAmountValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"pool"},"name":{"kind":"Name","value":"boostPoolByPoolId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmount"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableAmountValueUsd"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pool"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pool"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}}]}}]} as unknown as DocumentNode<GetFilteredLpAccountsWithBalancesQuery, GetFilteredLpAccountsWithBalancesQueryVariables>;
export const GetCachePoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCachePools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baseLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityFeeHundredthPips"}}]}}]}}]}}]} as unknown as DocumentNode<GetCachePoolsQuery, GetCachePoolsQueryVariables>;
export const GetCachePoolsWithOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCachePoolsWithOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pools"},"name":{"kind":"Name","value":"allPools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAsset"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"rangeOrderPrice"}},{"kind":"Field","name":{"kind":"Name","value":"baseLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"quoteLiquidityAmount"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityFeeHundredthPips"}},{"kind":"Field","name":{"kind":"Name","value":"openOrders"}}]}}]}}]}}]} as unknown as DocumentNode<GetCachePoolsWithOrderQuery, GetCachePoolsWithOrderQueryVariables>;
export const BannerStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BannerStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"app"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"App"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"banner"},"name":{"kind":"Name","value":"allBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"app"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"ALL"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<BannerStatusQuery, BannerStatusQueryVariables>;
export const GetLatestAuctionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestAuction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"auction"},"name":{"kind":"Name","value":"auctionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minActiveBid"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockNumber"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockNumber"}},{"kind":"Field","name":{"kind":"Name","value":"currentHeight"}},{"kind":"Field","name":{"kind":"Name","value":"projectedLockup"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionPeriodAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"targetSetSize"}},{"kind":"Field","name":{"kind":"Name","value":"authorityRotationEnabled"}}]}}]}}]} as unknown as DocumentNode<GetLatestAuctionQuery, GetLatestAuctionQueryVariables>;
export const GetBitcoinBoostSafeModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBitcoinBoostSafeMode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBoostSafeModes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"Bitcoin"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boostDepositsEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<GetBitcoinBoostSafeModeQuery, GetBitcoinBoostSafeModeQueryVariables>;
export const GetAllEnvironmentAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllEnvironmentAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allEnvironmentAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redemptionTax"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllEnvironmentAddressesQuery, GetAllEnvironmentAddressesQueryVariables>;
export const GetLatestFlipSupplyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestFlipSupplyQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"flipSupply"},"name":{"kind":"Name","value":"flipSupplyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalIssuance"}},{"kind":"Field","name":{"kind":"Name","value":"offchainFunds"}},{"kind":"Field","name":{"kind":"Name","value":"annualSystemCompoundedRewards"}}]}}]}}]} as unknown as DocumentNode<GetLatestFlipSupplyQueryQuery, GetLatestFlipSupplyQueryQueryVariables>;
export const ValidatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Validators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}}]}}]} as unknown as DocumentNode<ValidatorsQuery, ValidatorsQueryVariables>;
export const GetValidatorsByAccountIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorsByAccountIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CacheValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CacheValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Validator"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idHex"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"isCurrentBackup"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isBidding"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyholder"}},{"kind":"Field","name":{"kind":"Name","value":"reputationPoints"}},{"kind":"Field","name":{"kind":"Name","value":"lockedBalance"}},{"kind":"Field","name":{"kind":"Name","value":"unlockedBalance"}}]}}]} as unknown as DocumentNode<GetValidatorsByAccountIdsQuery, GetValidatorsByAccountIdsQueryVariables>;
export const GetLinkedAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLinkedAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ethAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"links"},"name":{"kind":"Name","value":"allAccountLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ethereumAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ethAddress"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountIdSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unregistered"},"name":{"kind":"Name","value":"allUnregistereds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>;